import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "ol/ol.css";
import { Map, View } from "ol";
import TileLayer from "ol/layer/Tile";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import SourceImagestatic from "ol/source/ImageStatic";
import LayerImage from "ol/layer/Image";
import XYZ from "ol/source/XYZ";
import { defaults } from "ol/control";
import Attribution from "ol/control/Attribution";
import { transformExtent, fromLonLat, transform, toLonLat } from "ol/proj";
import Projection from "ol/proj/Projection";
import Point from "ol/geom/Point";
import Style from "ol/style/Style";
import StyleIcon from "ol/style/Icon";
import StyleText from "ol/style/Text";
import StyleFill from "ol/style/Fill";
import StyleStroke from "ol/style/Stroke";
import Feature from "ol/Feature";
import { GeoJSON } from "ol/format";
import DragPan from "ol/interaction/DragPan";
import MouseWheelZoom from "ol/interaction/MouseWheelZoom";
import DoubleClickZoom from "ol/interaction/DoubleClickZoom";
import PinchRotate from "ol/interaction/PinchRotate";
import Overlay from "ol/Overlay";
import { toLine, getImg, formatRGBA, getformatstruct, getformitemsdata, getformListItemsdatas, bd_decrypt } from "@/utils/utils";
import { mapState, mapGetters, mapMutations } from "vuex";
import mapv2assembly from "@/view/map/customv2/hbckfzdlmmap";
import mappopupv2 from "@/components/mapv2/popupv2/index";
import typev2 from "@/components/mapv2/typev2/index";
import pointlistv2 from "@/view/map/hdmconfigv2/pointlist";
import axios from "axios";
import { BMapLoader } from "@/utils/bdMap.js";
import { ElMessage, ElMessageBox, ElNotification } from "element-plus";
import routelist from "@/view/map/hdmconfigv2/routelist";
import maptools from "@/view/map/hdmconfigv2/maptools";
export default {
  name: "hbckfzdlm",
  components: {
    mapv2assembly,
    mappopupv2,
    typev2,
    pointlistv2,
    routelist,
    maptools
  },
  props: {
    // 0配置页 1展示页
    id: {
      type: Number,
      default: 1
    },
    mapform: {
      type: Object,
      default: {}
    },
    style: {
      type: Object,
      default: {}
    },
    typelist: {
      type: Array,
      default: []
    },
    isloadingmap: {
      type: Boolean,
      default: false
    },
    maplayer: {
      type: Object,
      default: {}
    },
    viewInfo: {
      type: Object,
      default: {}
    },
    streetcode: {
      type: Array,
      default: []
    },
    mappointList: {
      type: Array,
      default: []
    },
    culturalList: {
      type: Array,
      default: []
    },
    maptemplate: {
      type: Number,
      default: 0
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    routelist: {
      type: Array,
      default: []
    },
    rtypelist: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      lineJsonData: [{
        lid: "1521",
        mid: "1517",
        rid: "1519"
      }, {
        lid: "185",
        mid: "181",
        rid: "183"
      }, {
        lid: "191",
        mid: "187",
        rid: "189"
      }, {
        lid: "197",
        mid: "193",
        rid: "195"
      }, {
        lid: "227",
        mid: "223",
        rid: "225"
      }, {
        lid: "221",
        mid: "217",
        rid: "219"
      }, {
        lid: "209",
        mid: "205",
        rid: "207"
      }, {
        lid: "171",
        mid: "169",
        rid: "173"
      }, {
        lid: "165",
        mid: "163",
        rid: "167"
      }, {
        lid: "201",
        mid: "199",
        rid: "203"
      }, {
        lid: "161",
        mid: "157",
        rid: "159"
      }, {
        lid: "213",
        mid: "199",
        rid: "215"
      }],
      geoJsonData: {
        type: "FeatureCollection",
        features: [{
          type: "Feature",
          geometry: {
            type: "GeometryCollection",
            geometries: []
          },
          properties: {
            type: "circle",
            coordinate: [12834937.619134754, 3610451.259313432]
          }
        }, {
          type: "Feature",
          geometry: {
            type: "GeometryCollection",
            geometries: []
          },
          properties: {
            type: "circle",
            coordinate: [12725974.550809814, 3623423.053161639]
          }
        }, {
          type: "Feature",
          geometry: {
            type: "LineString",
            coordinates: [[12725974.550809814, 3623423.053161639],
            // [12725974.550809814 - 10000, 3770436.7167746522 - 10000],
            [12725974.550809814, 3770436.7167746522]]
          },
          properties: {
            findex: 1
          }
        }, {
          type: "Feature",
          geometry: {
            type: "GeometryCollection",
            geometries: []
          },
          properties: {
            type: "circle",
            coordinate: [12725974.550809814, 3770436.7167746522]
          }
        }, {
          type: "Feature",
          geometry: {
            type: "GeometryCollection",
            geometries: []
          },
          properties: {
            type: "circle",
            coordinate: [12726839.337066362, 3611316.045569979]
          }
        }, {
          type: "Feature",
          geometry: {
            type: "LineString",
            coordinates: [[12834937.619134754, 3610451.259313432], [12909309.237197807, 3610451.259313432]]
          },
          properties: {
            findex: 9
          }
        }, {
          type: "Feature",
          geometry: {
            type: "GeometryCollection",
            geometries: []
          },
          properties: {
            type: "circle",
            coordinate: [12909309.237197807, 3610451.259313432]
          }
        }, {
          type: "Feature",
          geometry: {
            type: "GeometryCollection",
            geometries: []
          },
          properties: {
            type: "circle",
            coordinate: [12658521.222799137, 3665797.579732449]
          }
        }, {
          type: "Feature",
          geometry: {
            type: "LineString",
            coordinates: [[12658521.222799137, 3665797.579732449], [12924875.389815656, 3665797.579732449]]
          },
          properties: {
            findex: 10
          }
        }, {
          type: "Feature",
          geometry: {
            type: "GeometryCollection",
            geometries: []
          },
          properties: {
            type: "circle",
            coordinate: [12924875.389815656, 3665797.579732449]
          }
        }, {
          type: "Feature",
          geometry: {
            type: "GeometryCollection",
            geometries: []
          },
          properties: {
            type: "circle",
            coordinate: [11983123.156435823, 3853456.1974031776]
          }
        }, {
          type: "Feature",
          geometry: {
            type: "LineString",
            coordinates: [[12299634.926332075, 3829242.1822198573], [11983123.156435823, 3829242.1822198573], [11983123.156435823, 3853456.1974031776]]
          },
          properties: {
            findex: 14
          }
        }, {
          type: "Feature",
          geometry: {
            type: "GeometryCollection",
            geometries: []
          },
          properties: {
            type: "circle",
            coordinate: [12171646.560363099, 3764383.212978822]
          }
        }, {
          type: "Feature",
          geometry: {
            type: "LineString",
            coordinates: [[12458755.597536748, 3764383.212978822], [12171646.560363099, 3764383.212978822]]
          },
          properties: {
            findex: 3
          }
        }, {
          type: "Feature",
          geometry: {
            type: "GeometryCollection",
            geometries: []
          },
          properties: {
            type: "circle",
            coordinate: [12299634.926332075, 3829242.1822198573]
          }
        }, {
          type: "Feature",
          geometry: {
            type: "GeometryCollection",
            geometries: []
          },
          properties: {
            type: "circle",
            coordinate: [11985717.515205465, 3654555.3583973357]
          }
        }, {
          type: "Feature",
          geometry: {
            type: "LineString",
            coordinates: [[12377465.689421318, 3621693.4806485446], [11985717.515205465, 3621693.4806485446], [11985717.515205465, 3654555.3583973357]]
          },
          properties: {
            findex: 15
          }
        }, {
          type: "Feature",
          geometry: {
            type: "GeometryCollection",
            geometries: []
          },
          properties: {
            type: "circle",
            coordinate: [12070466.568347085, 3530890.923711095]
          }
        }, {
          type: "Feature",
          geometry: {
            type: "LineString",
            coordinates: [[12184618.354211306, 3530890.923711095], [12070466.568347085, 3530890.923711095]]
          },
          properties: {
            findex: 5
          }
        }, {
          type: "Feature",
          geometry: {
            type: "GeometryCollection",
            geometries: []
          },
          properties: {
            type: "circle",
            coordinate: [12184618.354211306, 3530890.923711095]
          }
        }, {
          type: "Feature",
          geometry: {
            type: "GeometryCollection",
            geometries: []
          },
          properties: {
            type: "circle",
            coordinate: [12377465.689421318, 3621693.4806485446]
          }
        }, {
          type: "Feature",
          geometry: {
            type: "GeometryCollection",
            geometries: []
          },
          properties: {
            type: "circle",
            coordinate: [12847044.626726413, 3366581.5349671394]
          }
        }, {
          type: "Feature",
          geometry: {
            type: "LineString",
            coordinates: [[12798616.596359774, 3524837.4199152654], [12798616.596359774, 3366581.5349671394], [12847044.626726413, 3366581.5349671394]]
          },
          properties: {
            findex: 8
          }
        }, {
          type: "Feature",
          geometry: {
            type: "GeometryCollection",
            geometries: []
          },
          properties: {
            type: "circle",
            coordinate: [12674087.375416987, 3370040.6799933277]
          }
        }, {
          type: "Feature",
          geometry: {
            type: "LineString",
            coordinates: [[12701760.535626495, 3474679.817035531], [12701760.535626495, 3370040.6799933277], [12674087.375416987, 3370040.6799933277]]
          },
          properties: {
            findex: 7
          }
        }, {
          type: "Feature",
          geometry: {
            type: "GeometryCollection",
            geometries: []
          },
          properties: {
            type: "circle",
            coordinate: [12701760.535626495, 3474679.817035531]
          }
        }, {
          type: "Feature",
          geometry: {
            type: "GeometryCollection",
            geometries: []
          },
          properties: {
            type: "circle",
            coordinate: [12798616.596359774, 3524837.4199152654]
          }
        }, {
          type: "Feature",
          geometry: {
            type: "LineString",
            coordinates: [[12726839.337066362, 3611316.045569979], [12726839.337066362, 3351015.382349291]]
          },
          properties: {
            findex: 2
          }
        }, {
          type: "Feature",
          geometry: {
            type: "GeometryCollection",
            geometries: []
          },
          properties: {
            type: "circle",
            coordinate: [12726839.337066362, 3351015.382349291]
          }
        }, {
          type: "Feature",
          geometry: {
            type: "GeometryCollection",
            geometries: []
          },
          properties: {
            type: "circle",
            coordinate: [12458755.597536748, 3764383.212978822]
          }
        }, {
          type: "Feature",
          geometry: {
            type: "GeometryCollection",
            geometries: []
          },
          properties: {
            type: "circle",
            coordinate: [12467403.460102221, 3423657.4278992503]
          }
        }, {
          type: "Feature",
          geometry: {
            type: "LineString",
            coordinates: [[12488158.330259351, 3518783.9161194353], [12488158.330259351, 3423657.4278992503], [12467403.460102221, 3423657.4278992503]]
          },
          properties: {
            findex: 6
          }
        }, {
          type: "Feature",
          geometry: {
            type: "GeometryCollection",
            geometries: []
          },
          properties: {
            type: "circle",
            coordinate: [12488158.330259351, 3518783.9161194353]
          }
        }, {
          type: "Feature",
          geometry: {
            type: "LineString",
            coordinates: [[12523614.566777784, 3659744.0759366187], [12523614.566777784, 3842213.9760680646]]
          },
          properties: {
            findex: 0
          }
        }, {
          type: "Feature",
          geometry: {
            type: "GeometryCollection",
            geometries: []
          },
          properties: {
            type: "circle",
            coordinate: [12523614.566777784, 3659744.0759366187]
          }
        }, {
          type: "Feature",
          geometry: {
            type: "GeometryCollection",
            geometries: []
          },
          properties: {
            type: "circle",
            coordinate: [12523614.566777784, 3842213.9760680646]
          }
        }]
      },
      extentsForCity: [{
        code: 420300,
        extent: [12182083.956809878, 3698129.7124782563, 12422200.853576653, 3932544.780264272]
      }, {
        code: 420600,
        extent: [12329750.931139518, 3661893.4957286157, 12592913.74548777, 3847573.512216565]
      }, {
        code: 421300,
        extent: [12548380.407306671, 3674762.379735978, 12705237.894685451, 3820752.677173649]
      }, {
        code: 420900,
        extent: [12613756.563137708, 3552145.8177919993, 12756855.629371384, 3744765.9284734004]
      }, {
        code: 421100,
        extent: [12734598.65713191, 3467152.553432425, 12928709.991341095, 3712115.750552687]
      }, {
        code: 420100,
        extent: [12656683.473857919, 3499007.081844425, 12811430.788969222, 3680355.17135522]
      }, {
        code: 420700,
        extent: [12746091.281361409, 3504941.4796900754, 12812209.13484885, 3583686.4387324476]
      }, {
        code: 420200,
        extent: [12749074.755034158, 3440083.0637134993, 12859295.498342551, 3546030.067210596]
      }, {
        code: 421200,
        extent: [12638436.873483011, 3378799.7321935156, 12798857.14116463, 3542316.9233604185]
      }, {
        code: 429006,
        extent: [12533203.887168352, 3551670.7005934874, 12631594.596870653, 3620801.316637058]
      }, {
        code: 429004,
        extent: [12572204.670767777, 3511677.014417206, 12671434.284152694, 3572513.8412985867]
      }, {
        code: 429005,
        extent: [12523103.424490714, 3513019.7119893115, 12583444.575642422, 3587283.5920965397]
      }, {
        code: 421000,
        extent: [12383003.058589276, 3429987.9762009103, 12701251.321081163, 3589184.3363311286]
      }, {
        code: 420800,
        extent: [12451769.11555395, 3553753.76164838, 12634785.570074243, 3713292.6751461467]
      }, {
        code: 420500,
        extent: [12273005.1527907, 3495636.5606775926, 12478003.97847743, 3707518.547942469]
      }, {
        code: 422800,
        extent: [12062755.251293007, 3389701.564667663, 12317261.750717685, 3684736.8880857965]
      }, {
        code: 429021,
        extent: [12237930.384992575, 3670596.142724349, 12355095.12681716, 3745600.2682872736]
      }],
      hightlightCity: [{
        //   url: "img/shiyanshi.bc9364dd.png",
        url: require("@/assets/map/26091/newZhanshi/shiyanshi.png"),
        projection: "EPSG:3857",
        city: "十堰市",
        imageExtent: [12182083.956809878, 3698129.7124782563, 12422200.853576653, 3932544.780264272]
      }, {
        //   url: "img/xiangyang.95e7b048.png",
        url: require("@/assets/map/26091/newZhanshi/xiangyangshi.png"),
        projection: "EPSG:3857",
        imageExtent: [12329750.931139518, 3661893.4957286157, 12592913.74548777, 3847573.512216565],
        city: "襄阳市"
      }, {
        //   url: "img/shennongjia.47ca7f7a.png",
        url: require("@/assets/map/26091/newZhanshi/shennongjia.png"),
        projection: "EPSG:3857",
        imageExtent: [12237930.384992575, 3670596.142724349, 12355095.12681716, 3745600.2682872736],
        city: "神农架"
      }, {
        //   url: "img/suizhoushi.e76f72ba.png",
        url: require("@/assets/map/26091/newZhanshi/suizhoushi.png"),
        projection: "EPSG:3857",
        imageExtent: [12548380.407306671, 3674762.379735978, 12705237.894685451, 3820752.677173649],
        city: "随州市"
      }, {
        //   url: "img/xiaoganshi.521ed4cb.png",
        url: require("@/assets/map/26091/newZhanshi/xiaoganshi.png"),
        projection: "EPSG:3857",
        imageExtent: [12613756.563137708, 3552145.8177919993, 12756855.629371384, 3744765.9284734004],
        city: "孝感市"
      }, {
        //   url: "img/huanggangshi.c740defc.png",
        url: require("@/assets/map/26091/newZhanshi/huanggangshi.png"),
        projection: "EPSG:3857",
        imageExtent: [12734598.65713191, 3467152.553432425, 12928709.991341095, 3712115.750552687],
        city: "黄冈市"
      }, {
        //   url: "img/wuhanshi.84d28830.png",
        url: require("@/assets/map/26091/newZhanshi/wuhanshi.png"),
        projection: "EPSG:3857",
        imageExtent: [12656683.473857919, 3499007.081844425, 12811430.788969222, 3680355.17135522],
        city: "武汉市"
      }, {
        //   url: "img/huangshishi.fb770d6a.png",
        url: require("@/assets/map/26091/newZhanshi/huangshishi.png"),
        projection: "EPSG:3857",
        imageExtent: [12749074.755034158, 3440083.0637134993, 12859295.498342551, 3546030.067210596],
        city: "黄石市"
      }, {
        url: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEkAAABXCAYAAABIr2g3AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAABgeSURBVHgB3V1pkFzVdT73Ld09rZHUQmhFS8sCJFkS9BgoGwdFoyxsSYohLIWXCqKyVWzKiCJVqThUNPrhVLkSh1GlUlmcKonEMcQ4kfhhcJxUzQgIDggjiVUGSdPa0TbTkka9vveuzzn33Pd6RgJGo6U1PlSrZ7pfv373e2f9zrmDgitAvv1PR7o+Mye1YcvWcm7m1T4svS7dc+8dkx+HK0QUtFBWr+nPadfbEAF0TWpXcGIwAt8HWHHTBHjj3crqf/7WnKfhCpCWgfTDFwa7TgzqDS+/cSanNV6IMhdTrgeQTXlQD6OSqkcdz/7jgiK0WC47SKQ9n10yccPs6W7X1rcrcHwgBALJcfCBVxOiWrmOubRqEG6vOwOrNvd0lKCFcllBevTJg12nynpDGOmc7ykIAs1XoOVCHFQnjYjh+wiUgik5Fz63LN2z+r6pLfVPlxykr32rv/AryycW0invnoGBsOvlrWV+PRITIyFN4osRkyOQHASJgPz127KgPNXxld+ash1aJB5cRNm0aTDfyEDn69sqN+7aX+1ETclXTru5fYcCKFcCOHg4YK2xPojNjIBxDDD0ZoQwocUBWRxp2qEjAcyZ40+GFspFA+kHPxkshIHqPXCwkTs5FCIIClIpBSdPh/DTbWcgk3LBQ2fjiroQQGRaWhl7Y23CnyPRIgvkW+/VYNv7NWilXBSQHvhaf+H99+u9tVqU232gDo1QMwAuemOHtURBHbWiEQSQ8l32PR6pED7IvAgQ8kEkWkxQjXhupVwwSF9e01+oowa9u6uao4WT2WgdQcpzGCRCAXGBWiNkcEisppBWkamR9hBcBCwdExm1wvcUZDMKzlQcaKVc0LevXnOg4CivFxeXowUGCE4oC1USqTQC4JOZsfPRrDn1IIJ6FBn/FBl/xD4JxHlLxKPPdyzLwL13tUMrZcyatOlHg4VKqHr/95WhXBi5EIQRawO6HtQAB8JQs1OuNSL0RfhcrbOHNjoDmDC6DEINP0eK47libpwVmJ8DBI6xC6ClMmaQItdd+8Gucu5M1ZgRm4wypoP/8GtVzJ5JQypVjGoIRnZCirNpWjdpVg016mSpDG3tKSCgM2SXkKQCdKrSKUw2w9aiNGaQHEf3pXzVNVRt8IIJnBS4vLooNKbUCCLWlnQ6xccQCPSMJQceg6aI/znou0hjfLySBr5O7/vky8CY7Vs7q3jC1ka3sfukM9HT73xYZedsk0GbmjbE9ByKbuiPJHCxQw4jA9zpoTpGOAcmT8zApLYUAzJUafB7dJzNoThluKjZ3PnLmEG6994pJaWdvjY0nwlpD52zmAo+6LUIPTKvD0HyPaMZtPhKPWQzS2c8/nKPQTTak834XOBaJ07/Tpnkwsxca1G6oOiGOc1mYKMxjpe0gDQokhyJzCtNXhtfq6MDRyWCNgQ0ha+1p30O8QQImRuBU601+POhRD56Xr4kAytubW10uyCQUjp4mhZJ5kXSCLQkf4p9C2kJ/R7i+46rQNImMT+jLaxdCE4ZfRu/ohTI6TgSRrEtt04uCKSNPQtKKz8/oW/aVR5rBS2rFoRoeopNqILacaYWsEaQCXJyCea9IIriyt9FMLEARsLNRW2LTD0HJgIe/KgBHx1vbXS74FR2xlXe5tkzPM6LyPeQ9lDORNpVrYWUR3OU45oMjBY5om1SrrE/otqOnDR91hUNpMN272vAy1uHoJVyMfL9LbOnpRCUEMTf8kJrjQAXqqGOjtpHH1TFsiSQ1ECLOXJmjr+74rxJ49JS21krc1of3C78+3fvq28aPBVy6WG9B9MdkanR6EVaPAFFDtqTssWYlDbao01pQlpoKRMtTME1M3xo1Fvrly5Ikx78Rn/3tveq+QOHjbawEw/Ep4hJcVJICaKrTEYutEhoSw5lixBTxgSskTrO4BfOT8GKW8ZJdPvhiyc3PPLnex9+aE1/nn7f9OJgvi3jrqV1krNlhwtJgUpmw/mRAEcsgKFJACpoio3QJJWm8jf5Ep2L0gMGCQzEx05g1HOiLmihjBqkD/bUOqOGszHt+f3/9eNTvZFyeqdP9YwTZnoDWJsIGNIUWqjCh5/yDTXCX8YHs4nR8cQ7MbUi7xn+SfHDFa5p1946bH+vsuahR/s7oUUyakrr4ScObMO7XiBfM+0qLEYzDhQP1tkZk4ZQdCPnTVRJDZ01IdXAFKC9PcP+ymiYAYkyAS3g2DQgAsspme8zjt0wAUZ0saKijs2YdsBlllFrEt7xkjY+FY4NhrDvkClsSXvoRfIlrBmhSR4JIAffo9coh6K1ljFppONAOiK1esDQMBDoqZmLEq2zSaRSBsQJbW7+ri9MWgstkFGD1LG0rXj1VV6c6Fla1QQwbUyNzURyITAULf1MPomEMmkT6rXRKja7iAGh5JLM0GUmU8XHaymKiZfK+GrNcy+e7IbLLKMG6TNzfKy7VBzmoSkq8+KICsGsOYNgefhwPKM9pC30qKPj1rhYypeslhBLEIQGIBPtdOzMXcngufWExxFH3vfaELzxVnntQ4/t7bcB5HLIqEFCLr/k+zZYQ+zNyESYRFMmzHvouLNYvHKYZ94oks6H4ZzYFAUYLWCRP4ubk+LcHdE0zqmAmV84eSaEA4epRFH59ja//7kXB7uxjZWDSyyjTiZffq1cKleiYY1EEkvua3G89FsD6zdFvLaNchKtHLHVIDSdNdc2BOR9ZjXltrlgTDXUVmnlGG3KG/qmfQeCtbNmemv//nvHS6++USmiZhbR5xXvXDGxmJ0AO9CSSw9ehKbmqKPbVx/f/xiuocd+QBlrSIh7bbsgSHugSZEfIjBsJs6ct2uI/4CKYDTNlEsUb4ia5wl5Z8zLE9+mQcXd3KiJY2JzlCLZaJ8ATf4Of/nswhRMxQjs+w4cPRbAz3fXi3geBFAXH7h7chG7OTswTpS8KmwnXuzT1j5qTcI7eDLWGp10Ye3vkQlJ/FqKilz0IZaurbHj1lyqkCnWJMvmf/FnjoBx5W/ANqHflDAQa6/i1CFukUsQAK7vnLgd9f5ubDrshngQA9/O4z/5FPrU93bVIDfJ4Rb6z/fU4Ctr9lPULk6d6hRvuzlbjEJ4/ku/M6VvTCD95hezUDqt4WfvVGPNsWKreVkKm0kmZZzyGWQCwtBMjqSw0ueoxwSdoUg88UdazNJ0SyBeML+ulGiubVfJ9yJAFBDaMn48aDHMOJTRXLJP9pHozt7fXYuP4MiM7TA8f6Fcjgof9Ndh0YJUAd/qa177qB13+0S3mG1LDrfmNrL01MJP08VRKcKuWBl/ROR/HQEjE6s2DM9ETEHI0c3w4kzSaR3z5EroE23Rk2+k37ltjoGCvkeLwnGk5LJGPJljK8j4AiFqurl2LZUKZvcI0o53q4WuNf25MYHkoRMkFbUaZBPLsClz1vJwJAGk16iG88SnmMGIiEsXetjKn0Coc2cl4mO1MAfQ5ADJJEnqYSRmacyLOsUOd2iMGfL36CbtBOP8wTYYwERKAJPNK1FLulnErO7aX8+pOqwctnYYpTz/P6VSQw5vNjXrMyIBBySRJCc9KZviRTl4lZ5nj3d4YWSKoBJwOdQ7Tnx+aizYFIEcfF1iGhXAjcBQM5HcpIYECA4clPGT9grGoYbYuUfWHJUxY6+p02OpYqFxqKB+Pl4jjFVUEtmUavJJ2txBe2KKOFqZC0rhwm2ZwVGPMm1cBSWhbWlXIppJJ8r1BlBPjwDg1pJk764yaUUkCactjJXkU+Y4J261R7pJ2yU6sDlG8TJiP2griVlTU8NYh1GDhHx2cUK26XBrWwBNdwOk7pKTi6YQOHW8+/SoIudNz1SOECikVdRRoYUpMRdKF8K6ycxPniwzWFo4JpuYsgLLRJwnjb1I/JS9FtOqMkDZTN+RG8dNVPoureMrN00LDUsXZXKYqHaeN0gkd/xquzSQkqEGe0FngaUTsGghlAuZ7okSKtcUtY6UNLxIc2b+jlDO7yHVcrrcMAVxQCxDJK7KDHvxHJTnxq9ZTQbbCKVzOASMY75XS+c4YQaTmQMwvNZAKSTTXzkmkPDcGOHUsKgQB50maTY/MisytcX5NmjHUI3lBEzEZ3LoDKbw2XbshkFQXBWzhhnF0MwgRAI8aSIBZqKrlsinYlN2mmiZQBx9BhPLNuyl2wCpIwMig6CUaJSR4wMBHdc1JpDOYFnSaCSgjCxRzAXbnyU3wX+uy6fgc8uwnd1uZpZsGUJmouSY4bNLqPq+x6boy4AFmYbniAkheKQ9dmIubigoc84MfpYATvlOTAjaXK45CtsUxjZVbQVB8+Svbi0Xfv+JQ/PPG6T/fmmoFAQJAHrE++ocVc4EzK0WX5umb++Zf40kfRLi2anqKE4Q7TwTmeL0q1Nw/YI0dCxpw6TT5cLZc92YsQwkt7I3gq4mFIduHbCSZDSSFrsSEo+pGnPBJn0QoCw7Qc9HTwRIM4dd5w0SSknOLQVtcndioEbgREXxrr2N7vvunPz4WztrffbOUV5kaFqHz3X1FA+Irwoj07+7fl52+w2L2nrmz/FLE7Iem2wyS0njzREvmEzPfG9yi2z+RldGGmVDPVmXdeggaYEtsTi3c1T8Ozt2x5jcebWUcpO9IvXRypXEPIQfAyrPmoteq2V4F4tPfn3aOvo5BO+RtB9s8zyVO33GaqOG/JwU3LQsU6zW9OZDxxp9NSfc8hdfn8435M/++kDBU6rTpaEvCeWUJ9FnaxgpabaA0oRIK64ZG4REaKJZ2vfERIFLngbdAAQsZj0hmbBzHeP8tTKaQ6/PnZHq3IBUzHmB9Gu3ZpH0qsBeHpEREJocdySGruiCfcUJ5Kmaih3gsz2zis+9MLiuXNVPvfT6GTg9hIvFi6ZdAXjGVV/tmlIc+Z0f9lefzqRSncY8TAOTCmbyVzzR6xj+nEzUccS3KJPpswlKPuTYIVbrl0RdbL1gzVjLZ+hMC+dhkMm694za3L77zLFO/GSnkoQu/iKdmJgtTOnOLUE/tPLzEzb+x9/O2dF8ngfuntKTzaoupDE2KleVll7HDn3jl+46GyAGPuVuvnl5W4k25tgWOYFDdzols5ieTPmSc4+ihMCzBqi4rImEv9JxiuAIqedL2WR8WuLUyWKACuBPwQao2GsHr3vSJPcxmoQ9fDRIUgCAYXWb9VFUCN+xYkKxjtrxcYu3gu2pe2o63PFJx/3nj08+dexEsIa0T66fR3koPSCHbuuvsAkgOwhm76IrtAqVSZ5MvGith103522OPY9CH+nCgnlexyeCtOkng4W3dzY27dxTzSewjEgBFAx7jZ6p67p8Udvq+++e9DRcJPnDb+5bfWpIr8UiO8++WgBwncQYdPO1gRTJ2jABlEyGwhB48hkGtMlZK8euS86kden76+dN+URzCyO1ARnGvC0HmoM+Bwj59MjotntvffPFBIjku381b6NyolXX5tMb78TMn5LakZK8IholVIsjF0qAcuEsR5nQL8dL0ura3IDNTvUBfEIKQFuu0EkXqINqQ+ZZeZBuUlWQZBJooji4JLuKnsX6sfsbMx7B3Gs7mYJS5zCEONuWXxU0DYKZZx5O1BDnTqH4VmpkzJ2dwqCgAP0gIFPZR8d/bHQLwO2kQQilbD0UJaoD8gVCL9Az3YFFCzMUqbp7/nJuES6RUCsJ2dHCkaNhTIEYhjExE3vjHEcJL2V8jUmpktrTiQ1DASW6NyzOgOfD5sPHaiVKVmdd7TNd8rEgoUNcSY4sDuvgcC7k2OqZCTOQDgbAzOkeLFmYLt736OR1cCklhE7qHjf7nqTbq+LXlORgcYGpm3YpyEFKJeOGZ8q6z0nrx++//ezuysea22//xsTOie0mbkWm3I6pD5C7ZBNK+lcm+vvgEkvH8vaHici3dK5lQa0Dt+VNMuZsyDybVZtjTA4nN7uE5cvq9WtnrXrw9nO3n86pSZt6B3OV01HheKlpVjESZk+ZpiNvjbAFLj724t3de6gOl1oWzkttPnSYh1A72zMOzJzhwsBAxFvGbCFsr0k13URoAuhajL6LsO207Z1Kz66jtXWfNoRxTpBKJ8LOwZL5MlMgAmfRcX6k1LC6LaFLLv1uovvvnLwen9ZT/nbdtOzKGxf7XXiNnVh85yn5w5JHyDNzvG0/OZKV34QOef5svxR5etXffHP2qBqX5wRpy6vVlaZTJioNKm7txC2epr1qdBHzr0nBzUiH/HsPXBahu7/Z8NDsXGlLmaO8lcgqdi2c63e++W4V9h1sxBdoi9v9qPGzp3s5z/DYYwcJAeh0JCySPXtcHEYxDQFSmiR8jNmNhO93/uBHg4UHW7Bf9vs9C+g76bH+H7CEqtd1r0kQjY5bFvPkUFRMcUnk9I323GclGuSP3nyzPrgf7d5u5KMUvi6DDzylBprrHUvRGjZHA81z37ysDV56bWjdv3x7bje0UP7kyUO918z0OmnbxWvbK0WkVTaix+h75qm5W+A85SyQ6I8aHBkIN73+ZjUmxTzeWaTjLekmmoD0uZrPhhmrK1vZAXqeWT+vZVvVicjHsnclaczv3j7xvIFplmEgPfPiYB4TrN5tb1fzxUNmFxFVz5wTyVQIaU/SnWimP23ylozi4DtFpO5XUaYM41iGhaNX/r+69mdvV/L9B+vC5GmZ8EjKV6cpYSMt0zFppZLRZKEjELB8YXG2l/wUjGOJQfrymr3dpZPB6v2Hw5hncZqJIpu5AsSDDFwCJPiB3TpKuAWR2Spx6EiYx0J5W3Mfa7wJL5HqIeT4+rmTE0bxJL/lZkJIGD/QMrcNMIy7UZIqxMWkhMFMSsEXb8oW/+ihqQtgnIpHQ+uYP/dueb0Mx7Df5Da1hjOeYf6UluECrWT6A5o6HKJokDQamQkQAqxaj+CnWyvdMI7Fw3Sr86MjQf7oiUbcQaDFEW1ALtgWtb5oV0McM0/I6iYWEIyPUlJIRskW9uKG71wZfwdprOLt/LAKA6dMO5j3OErLwwx9GAAilWiL79pCMgGUUwNl3rfzRKRxt3a0w77DtW4Y5+K9t6eKd9+NF81UiE4GRkm4wtZmG2j85zIkI7e+ifezNeVRs6b5MHeWX/zTP5g2rrWIxPFRfxxZuCsmFXNIwupFke0iJN0IoQBZeyyfzH13ARtb91RQ5sjnwTgX55Ybs7D4M2kZUdGmOWeHDcT/JJMkiVO2CSTNHtEPnvT4GUB87xRSFx/sqeV2fFDfNHK8bryJM3MmQFsGYh/E29DF0uzYry1qtaTYNre03DA9zB9vMdMZhi2gxmKdJlwLbdpdC+NYHL/qbq7WqMevY7YvtO0aCfOBjNzZ92W/jJliA4i3X8V5pTCXSlICbCKu+b3HDzwM41QcGvb+cE99oxn8NLyLzX94ciM0YFltMY0TFdMkJLwvJIqG7au19LIFeMUXsj3j1T9xPMdFPk9z1yTWr9gtDaQxPIQgjhykK8HHNZXHcdcGknIlFODIBPcequbwxadgHAoj872euX13rJzYN2OqF0+8JkAZQp20KJA2sX3YsO9IOWOPjZqnu4Q1GBiMaBRvXDrwuMDNeHodtoSS7Z6xP3HjUsNJVCmZ4dFRPI/NXQiZYIunOMBoWbkC8M7O1v71mrFKDNK9d03pO3I8KFnOyE7lc0ki+/ZJUp4XzzKGUXO31PRvbSJqN8nY3Uk1rOF2YuI6HmUYn7Rzd61HJ87FTIgBxPPTdpekNUglWmV/o+Prso/EAq0tJ6VkK+o4lGEgeRCsnz7VK6X8kayuinOfSHY4mj/2Y/f5J7lRBjXNjhEryZvqMkmVkHfjS4aBRH+g5bZbJmxctihttECiWPPefU9Gjtn/iNM2PXlLxOl4+0Pz34zMTXbhxiVpGI9yVjexrqP1jqsfQT3oox0AHUvTMG2qlwyDS/F6fT7FeZUd+Iz/ToRoWTbtwvLrMzBnhs8+jSY1FszxYTzKWX03mTjbSI+1Tx3Oz70m9XA243S/MlBmoPLX0BBoug8NLOf7ToFKD3fE/CFpF40lL5yf2nzgUGP7keMhT6Q4yinCOJRPdRKrn9jfiabSS8OfeHBfEEL3M383dwv1544f0b3/t7VciM+kTdCnv1x245JMcW7O7RjN9s0rXT4VJCwlOqsNWPtC71D3v41o7NGgV6T8XkwjCyrulDDdW6rpRsd4byVZueBwQ0A1wOvFHxko3gAIes2/fmfuevglkYsSkwmoG5a2907JeYWBgaDniT+edsX8TxAuhly0xIV8VFRXG5yyfuSXwQ81yy8AD2kxGBjaZWkAAAAASUVORK5CYII=",
        projection: "EPSG:3857",
        imageExtent: [12746091.281361409, 3504941.4796900754, 12812209.13484885, 3583686.4387324476],
        city: ""
      }, {
        //   url: "img/xianningshi.6b179e92.png",
        url: require("@/assets/map/26091/newZhanshi/xianningshi.png"),
        projection: "EPSG:3857",
        imageExtent: [12638436.873483011, 3378799.7321935156, 12798857.14116463, 3542316.9233604185],
        city: "咸宁市"
      }, {
        //   url: "img/tianmenshi.cc7cef53.png",
        url: require("@/assets/map/26091/newZhanshi/tianmenshi.png"),
        projection: "EPSG:3857",
        imageExtent: [12533203.887168352, 3551670.7005934874, 12631594.596870653, 3620801.316637058],
        city: "天门市"
      }, {
        url: "data:image/png;base64,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",
        projection: "EPSG:3857",
        imageExtent: [12572204.670767777, 3511677.014417206, 12671434.284152694, 3572513.8412985867],
        city: ""
      }, {
        url: "data:image/png;base64,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",
        projection: "EPSG:3857",
        imageExtent: [12523103.424490714, 3513019.7119893115, 12583444.575642422, 3587283.5920965397],
        city: ""
      }, {
        //   url: "img/jingmenshi.4b2b0956.png",
        url: require("@/assets/map/26091/newZhanshi/jingmenshi.png"),
        projection: "EPSG:3857",
        imageExtent: [12451769.11555395, 3553753.76164838, 12634785.570074243, 3713292.6751461467],
        city: "荆门市"
      }, {
        //   url: "img/yichangshi.ded8c2a4.png",
        url: require("@/assets/map/26091/newZhanshi/yichangshi.png"),
        projection: "EPSG:3857",
        imageExtent: [12273005.1527907, 3495636.5606775926, 12478003.97847743, 3707518.547942469],
        city: "宜昌市"
      }, {
        //   url: "img/jingzhoushi.6750dfe3.png",
        url: require("@/assets/map/26091/newZhanshi/jingzhoushi.png"),
        projection: "EPSG:3857",
        imageExtent: [12383003.058589276, 3429987.9762009103, 12701251.321081163, 3589184.3363311286],
        city: "荆州市"
      }, {
        //   url: "img/enshi.aed2dede.png",
        url: require("@/assets/map/26091/newZhanshi/enshi.png"),
        projection: "EPSG:3857",
        imageExtent: [12062755.251293007, 3389701.564667663, 12317261.750717685, 3684736.8880857965],
        city: "恩施土家族苗族自治州"
      }],
      hightlightCityXunke: [{
        // url: require("@/assets/map/26091/shiyanshi.png"),
        url: require("@/assets/map/26091/newXunke/shiyanshi.png"),
        projection: "EPSG:3857",
        city: "十堰市",
        imageExtent: [12182683.956809878, 3698729.7124782554, 12421600.853576653, 3931944.780264272]
      }, {
        // url: require("@/assets/map/26091/xiangyang.png"),
        url: require("@/assets/map/26091/newXunke/xiangyangshi.png"),
        projection: "EPSG:3857",
        imageExtent: [12329750.931139518, 3661893.4957286157, 12592913.74548777, 3847573.512216565],
        city: "襄阳市"
      }, {
        // url: require("@/assets/map/26091/shennongjia.png"),
        url: require("@/assets/map/26091/newXunke/shennongjia.png"),
        projection: "EPSG:3857",
        imageExtent: [12237930.384992575, 3670596.142724349, 12355095.12681716, 3745600.2682872736],
        city: "神农架"
      }, {
        // url: require("@/assets/map/26091/suizhoushi.png"),
        url: require("@/assets/map/26091/newXunke/suizhoushi.png"),
        projection: "EPSG:3857",
        imageExtent: [12548380.407306671, 3674762.379735978, 12705237.894685451, 3820752.677173649],
        city: "随州市"
      }, {
        // url: require("@/assets/map/26091/xiaoganshi.png"),
        url: require("@/assets/map/26091/newXunke/xiaoganshi.png"),
        projection: "EPSG:3857",
        imageExtent: [12613756.563137708, 3552145.8177919993, 12756855.629371384, 3744765.9284734004],
        city: "孝感市"
      }, {
        // url: require("@/assets/map/26091/huanggangshi.png"),
        url: require("@/assets/map/26091/newXunke/huanggangshi.png"),
        projection: "EPSG:3857",
        imageExtent: [12734598.65713191, 3467152.553432425, 12928709.991341095, 3712115.750552687],
        city: "黄冈市"
      }, {
        // url: require("@/assets/map/26091/wuhanshi.png"),
        url: require("@/assets/map/26091/newXunke/wuhanshi.png"),
        projection: "EPSG:3857",
        imageExtent: [12656683.473857919, 3499007.081844425, 12811430.788969222, 3680355.17135522],
        city: "武汉市"
      }, {
        // url: require("@/assets/map/26091/huangshishi.png"),
        url: require("@/assets/map/26091/newXunke/huangshishi.png"),
        projection: "EPSG:3857",
        imageExtent: [12749074.755034158, 3440083.0637134993, 12859295.498342551, 3546030.067210596],
        city: "黄石市"
      }, {
        url: "data:image/png;base64,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",
        projection: "EPSG:3857",
        imageExtent: [12746091.281361409, 3504941.4796900754, 12812209.13484885, 3583686.4387324476],
        city: ""
      }, {
        // url: require("@/assets/map/26091/xianningshi.png"),
        url: require("@/assets/map/26091/newXunke/xianningshi.png"),
        projection: "EPSG:3857",
        imageExtent: [12638436.873483011, 3378799.7321935156, 12798857.14116463, 3542316.9233604185],
        city: "咸宁市"
      }, {
        // url: require("@/assets/map/26091/tianmenshi.png"),
        url: require("@/assets/map/26091/newXunke/tianmenshi.png"),
        projection: "EPSG:3857",
        imageExtent: [12533203.887168352, 3551670.7005934874, 12631594.596870653, 3620801.316637058],
        city: "天门市"
      }, {
        url: "data:image/png;base64,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",
        projection: "EPSG:3857",
        imageExtent: [12572204.670767777, 3511677.014417206, 12671434.284152694, 3572513.8412985867],
        city: ""
      }, {
        url: "data:image/png;base64,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",
        projection: "EPSG:3857",
        imageExtent: [12523103.424490714, 3513019.7119893115, 12583444.575642422, 3587283.5920965397],
        city: ""
      }, {
        // url: require("@/assets/map/26091/jingmenshi.png"),
        url: require("@/assets/map/26091/newXunke/jingmenshi.png"),
        projection: "EPSG:3857",
        imageExtent: [12451769.11555395, 3553753.76164838, 12634785.570074243, 3713292.6751461467],
        city: "荆门市"
      }, {
        // url: require("@/assets/map/26091/yichangshi.png"),
        url: require("@/assets/map/26091/newXunke/yichangshi.png"),
        projection: "EPSG:3857",
        imageExtent: [12273005.1527907, 3495636.5606775926, 12478003.97847743, 3707518.547942469],
        city: "宜昌市"
      }, {
        // url: require("@/assets/map/26091/jingzhoushi.png"),
        url: require("@/assets/map/26091/newXunke/jingzhoushi.png"),
        projection: "EPSG:3857",
        imageExtent: [12383003.058589276, 3429987.9762009103, 12701251.321081163, 3589184.3363311286],
        city: "荆州市"
      }, {
        // url: require("@/assets/map/26091/enshi.png"),
        url: require("@/assets/map/26091/newXunke/enshi.png"),
        projection: "EPSG:3857",
        imageExtent: [12062755.251293007, 3389701.564667663, 12317261.750717685, 3684736.8880857965],
        city: "恩施土家族苗族自治州"
      }],
      arrXiangyang: [[12182683.956809878, 3698729.7124782563, 12421600.853576653, 3931944.780264272], [12548980.407306671, 3675362.379735978, 12704637.894685451, 3820152.677173649], [12238530.384992575, 3671196.142724349, 12354495.12681716, 3745000.2682872736], [12548980.407306671, 3675362.379735978, 12704637.894685451, 3820152.677173649]],
      arrWuhan: [[12614356.563137708, 3552745.8177919993, 12756255.629371384, 3744165.9284734004], [12533803.887168352, 3552270.7005934874, 12630994.596870653, 3620201.316637058], [12523703.424490714, 3513619.7119893115, 12582844.575642422, 3586683.5920965397], [12572804.670767777, 3512277.014417206, 12670834.284152694, 3571913.8412985867], [12657283.473857919, 3499607.081844425, 12810830.788969222, 3679755.17135522], [12674087.375416987, 3370040.6799933277, 12701760.535626495, 3474679.817035531], [12735198.65713191, 3467752.553432425, 12928109.991341095, 3711515.750552687], [12735198.65713191, 3467752.553432425, 12928109.991341095, 3711515.750552687], [12746691.281361409, 3505541.4796900754, 12811609.13484885, 3583086.4387324476]],
      arrYijingji: [[12063355.251293007, 3390301.564667663, 12316661.750717685, 3684136.8880857965], [12273605.1527907, 3496236.5606775926, 12477403.97847743, 3706918.547942469], [12452369.11555395, 3554353.76164838, 12634185.570074243, 3712692.6751461467], [12383603.058589276, 3430587.9762009103, 12700651.321081163, 3588584.3363311286]],
      isMobileflag: false,
      // 移动端判断
      query: "",
      formUserId: "",
      // 最外层样式
      mainStyle: {
        width: "",
        height: "",
        transform: "scale(1)",
        transformOrigin: "0 0",
        position: "relative"
      },
      // 除地图以外的数据集合
      mapelem: {
        bg: "",
        logo: "",
        pickey: "",
        golist: "https://p.ananas.chaoxing.com/star3/origin/3df243657b8ae7d4bd4eccd3446f3639.png"
      },
      // 除地图以外的样式集合
      modulestyle: {
        logo: "",
        pickey: "",
        type: "",
        list: ""
      },
      cTemplateScore: 0,
      popmodeltype: 0,
      // 弹窗默认模板样式
      pointdetail: {},
      popshowflag: false,
      showtype: 1,
      modeltype: 0,
      showlist: 1,
      typebtn: [],
      showgolist: false,
      showgolistId: 0,
      cform: {},
      // 非遗项目表单数据
      cformlabel: {},
      // 非遗项目表单结构标题集合
      cformoption: {},
      // 非遗项目表单结构默认选择项值集合
      cformfield: {},
      // 非遗项目表单校验集合
      cstructList: [],
      // 非遗项目表单结构数据
      cpList: [],
      // 添加或编辑非遗项目表单数据时列表
      defaultcform: {},
      // 非遗项目默认form数据
      cformUser: {},
      // 地图配置当前行ID数据
      formatData: {},
      // 地图配置当前行ID 格式化数据
      sList: [],
      // 添加或编辑地图表单数据时列表
      form: {},
      // 地图表单数据
      formlabel: {},
      // 地图表单结构标题集合
      formoption: {},
      // 地图表单结构默认选择项值集合
      formfield: {},
      // 地图表单校验集合
      mapview: {},
      loadingmap: false,
      mapLayers: {},
      mapstyle: {},
      jsonOption: {},
      typeList: [],
      // 分类列表数据
      mapstreetcode: [],
      typeform: {
        formId: "260297",
        page: 1,
        limit: 100,
        searchStr: ""
      },
      // 分类列表查询字段
      pointform: {
        formId: "165054",
        page: 1,
        limit: 100,
        searchStr: ""
      },
      // 点位查询字段集合
      // 搜索定位点字段
      searchStr: {
        model: 0,
        filters: [{
          model: 0,
          filters: [{
            alias: "40",
            compt: "editinput",
            express: "===",
            val: ""
          }]
        }, {
          model: 1,
          filters: []
        }]
      },
      coordinate: "",
      // 当前点击经纬度
      pointList: [],
      // 点位列表数据
      mapculturalList: [],
      // 非遗项目列表数据
      culturalform: {
        formId: "cultural_heritage_project",
        page: 1,
        limit: 100,
        searchStr: "",
        t: "57ed207dcf924429c45100c202c62142651c83312c7ae7d68a7aa7777892039a5066948fb3dc970fc240392e22722d5c"
      },
      // 非遗项目表单字段
      mapculturalpersonList: [],
      // 非遗人列表数据 culturalHeritageInheritor202405192327
      culturalpersonform: {
        formId: "cultural_heritage_inheritor",
        page: 1,
        limit: 100,
        searchStr: "",
        t: "57ed207dcf924429c45100c202c62142273459422eab738a2ef4681ff0d1e276d794a6b905f0918f3df30b1ce38395ba"
      },
      // 非遗人表单字段
      mapculturalpicList: [],
      // 项目图片列表数据 culturalpic2024052571429
      culturalpicform: {
        formId: "21416",
        page: 1,
        limit: 100,
        searchStr: "",
        t: "0bef8d07ada7bc791d6ebf0bcc4c8a8a"
      },
      // 项目图片表单字段
      mapculturalvideoList: [],
      // 项目视频列表数据 culturalvideo202405281701
      culturalvideoform: {
        formId: "12479",
        page: 1,
        limit: 100,
        searchStr: "",
        t: "ebc411877446a47bd84c8cb30c90410b"
      },
      // 项目视频表单字段
      maprouteList: [],
      // 路线列表数据
      mapcontainer: "",
      routeform: {
        formId: "1626576",
        page: 1,
        limit: 100,
        searchStr: "",
        t: "8cb8793ff32dba9935520c2f7473a33e83825a93035ae6268d91df56c28f60d9",
        orderType: "asc"
      },
      // 路线查询字段集合
      routePop: false,
      bdmaploaction: {},
      rtypeform: {
        formId: "1626580",
        page: 1,
        limit: 100,
        searchStr: "",
        t: "7e324a759ba7eeb834922850eb694d88cedc5ae94849013a92bd11cd2b9784dd"
      },
      // 路线分类列表查询字段
      rtypeList: [],
      // 路线分类列表数据
      mapTimer: null,
      routeAllSource: [],
      routeAllLen: 0,
      routePoint: [],
      cType: "",
      routejson: {},
      dialogVisible: false,
      vectorSource: null
    };
  },
  computed: {
    ...mapGetters(["mapv2info"])
  },
  watch: {
    mapform: {
      handler(val) {
        if (val) {
          this.form = val;
          this.mapformHandle(val);
        }
      },
      deep: true
    },
    style: {
      handler(val) {
        if (val) {
          // //////console.log(`supermapstyle`, val);
          this.mapstyle = val;
          this.styleHandle(val);
        }
      },
      deep: true
    },
    "style.typebtn": {
      handler(val) {
        if (val) this.typebtnFormat(val);
      },
      deep: true
    },
    "style.popcolor"(val) {
      if (val) this.popcolorFormat(val);
    },
    "style.typeall": {
      handler(val) {
        // //////console.log(`style.typeall`, val)
        this.mapstyle.typeall = val;
      },
      deep: true
    },
    "style.typeallname": {
      handler(val) {
        // //////console.log(`style.typeallname`, val)
        this.mapstyle.typeallname = val;
      },
      deep: true
    },
    viewInfo: {
      handler(val) {
        this.mapview = val;
      },
      deep: true
    },
    isloadingmap(val) {
      this.loadingmap = val;
    },
    maplayer: {
      handler(val) {
        this.mapLayers = val;
      },
      deep: true
    },
    typelist: {
      handler(val) {
        this.typeList = val;
      },
      deep: true
    },
    mappointList: {
      handler(val) {
        this.pointList = val;
      },
      deep: true
    },
    culturalList: {
      handler(val) {
        this.mapculturalList = val;
        // if (this.iseditpoint) this.addDrawInteractions1()
      },
      deep: true
    },
    maptemplate(val) {
      this.cTemplateScore = val;
    },
    streetcode(val) {
      this.mapstreetcode = val;
    },
    isMobile(val) {
      this.isMobileflag = val;
      this.changeMobile(val);
    },
    routelist: {
      handler(val) {
        this.maprouteList = val;
        this.routeHandle(this.maprouteList);
      },
      deep: true
    },
    rtypelist: {
      handler(val) {
        this.rtypeList = val;
      },
      deep: true
    },
    "mapv2info.style.typebtn": {
      handler(val) {
        if (val) this.typebtnFormat(val);
      },
      deep: true
    },
    "mapv2info.style": {
      handler(val) {
        // //////console.log(`this.mapv2info.style`, this.mapv2info.style)
        if (val) this.styleHandle(val);
      },
      deep: true
    },
    "mapv2info.style.popcolor"(val) {
      if (val) this.popcolorFormat(val);
    },
    "mapv2info.style.typeall": {
      handler(val) {
        this.mapstyle.typeall = val;
      },
      deep: true
    },
    "mapv2info.style.typeallname": {
      handler(val) {
        this.mapstyle.typeallname = val;
      },
      deep: true
    },
    "mapv2info.style.routebutton": {
      handler(val) {
        this.mapstyle.routebutton = val;
      },
      deep: true
    },
    "mapv2info.style.routebuttontext": {
      handler(val) {
        this.mapstyle.routebuttontext = val;
      },
      deep: true
    },
    "mapv2info.style.routepos": {
      handler(val) {
        this.mapstyle.routepos = val;
      },
      deep: true
    },
    "mapv2info.style.routebtn": {
      handler(val) {
        this.mapstyle.routebtn = val;
      },
      deep: true
    }
  },
  created() {
    this.mapconStyle();
  },
  mounted() {
    this.query = this.$route.query;
    this.formUserId = Number(this.query.formUserId);
    if (this.$route.query.edit) {
      this.iseditpoint = true;
    }
    //////console.log(`this.id`, this.id)
    // 展示页请求相关接口数据
    document.body.classList.add("nobg");
    if (this.id === 1) {
      this.setComonStyle();
      this.getMapData();
    }
    // 获取当前位置
    // this.$nextTick(() => { this.loadBmap()})
  },
  methods: {
    ...mapMutations(["SET_MAPSENIOR", "SET_MAPVIEW", "SET_MAPFORM", "SET_MAPFORMITEM", "SET_MAPSTYLEITEM", "SET_MAPDRAWLAYER", "SET_COORDINATE", "SET_MAPROUTESOURCE"]),
    loadBmap() {
      BMapLoader().then(BMap => {
        this.mapTimer = setInterval(() => {
          if (window.BMapGL && window.BMapGL.Map && window.BMapGL.Point) {
            this.mapcontainer = new BMap.Map("bdmap");
            let geolocation = new BMap.Geolocation();
            geolocation.getCurrentPosition(a => {
              //////console.log(a);
              this.bdmaploaction.address = a.address;
              this.bdmaploaction.lng = a.point.lng;
              this.bdmaploaction.lat = a.point.lat;
              localStorage.setItem("bdlocation", JSON.stringify(this.bdmaploaction));
            });
            clearInterval(this.mapTimer);
            this.mapTimer = null;
          }
        }, 100);
      });
    },
    mapconStyle() {
      this.mainStyle.width = `${window.innerWidth}px`;
      this.mainStyle.height = `${window.innerHeight}px`;
      if (window.innerWidth < 1081) this.isMobileflag = true;
    },
    percentageChange(scale) {
      this.mainStyle.transform = `scale(${scale})`;
    },
    /**
     * 定位点格式化
     */
    posFormat(val) {
      delete val.ptype;
      delete val.pIndex;
      return val;
    },
    popcolorFormat(val) {
      let obj = formatRGBA(val);
      let theme1 = `rgba(${obj.r},${obj.g},${obj.b},1)`;
      let theme2 = `rgba(${obj.r},${obj.g},${obj.b},0.7)`;
      document.documentElement.style.setProperty("--hand-drawn-pop-colortheme1", theme1);
      document.documentElement.style.setProperty("--hand-drawn-pop-colortheme07", theme2);
    },
    styleHandle(val) {
      // //////console.log(`styleHandle`, val)
      this.popmodeltype = val.popStyleIndex === undefined ? this.form.cTemplateScore === 1 ? 1 : 0 : val.popStyleIndex;
      this.modeltype = val.typeStyleIndex === undefined ? 0 : val.typeStyleIndex;
      Object.keys(this.modulestyle).forEach(key => {
        let pos = this.posFormat(val[`${key}pos`] !== undefined ? {
          ...val[`${key}pos`]
        } : {
          ...this.mapv2info.style[`${key}pos`]
        });
        let appPos = {};
        Object.keys(pos).forEach(item => {
          appPos[item] = this.isMobileflag ? `${parseFloat((parseInt(pos[item]) / 2 / 37.5).toFixed(6))}rem` : `${parseFloat((parseInt(pos[item]) / 1920 * 100).toFixed(6))}vw`;
        });
        this.modulestyle[key] = appPos;
      });
      if (val.typedisplay) this.modulestyle.type = Object.assign({}, this.modulestyle.type, val.typedisplay);
      // //////console.log(`this.modulestyle`, this.modulestyle)
    },
    mapformHandle(val) {
      if (!this.isMobileflag) {
        this.mapelem.bg = val.background_img && val.background_img.length > 0 ? getImg(val.background_img[0]) : "";
      }
      if (this.isMobileflag) {
        this.mapelem.bg = val.app_bg_img && val.app_bg_img.length > 0 ? getImg(val.app_bg_img[0]) : "";
      }
      this.mapelem.logo = val.logo && val.logo.length > 0 ? getImg(val.logo[0]) : "";
      this.mapelem.pickey = val.pickey && val.pickey.length > 0 ? getImg(val.pickey[0]) : "";
      this.showtype = val.showtype;
      this.showlist = val.showlist;
      this.isHasallarea(val);
      if (val.cTemplateScore === 1) this.getCulturalFormStruct();
    },
    changeMobile(val) {
      this.mapformHandle(this.form);
      if (val) {
        this.mainStyle.width = "375px";
        this.mainStyle.height = "667px";
      } else {
        this.mainStyle.width = `${window.innerWidth}px`;
        this.mainStyle.height = `${window.innerHeight}px`;
      }
    },
    //     addDrawInteractions1 () {
    //   this.addselectInteraction()
    //   this.adddragboxInteraction()
    // },
    /**
     * 选择绘制元素
     */
    //  addselectInteraction () {
    //   this.selectinter = new Select({
    //     style: (feature) => {
    //       let selectStyle = feature.getStyle()
    //       let score = feature.get('score')
    //       let type = feature.get('type')
    //       if (score === 1) {
    //         selectStyle = [new Style({
    //           image: new StyleIcon({
    //             src: feature.get('image'),
    //             anchor: [1.3, 0.5],
    //             scale: 0.5
    //           })
    //         }),
    //         new Style({
    //           text: new StyleText({
    //             textAlign: 'left',
    //             text: feature.get('name'),
    //             font: `14px sans-serif`,
    //             offsetY: 1,
    //             fill: new StyleFill({ color: '#ffffff' }),
    //             stroke: new StyleStroke({ color: '#045578', width: 2 })
    //           })
    //         })]
    //       }
    //       if (type === 'areapolygon') {
    //         selectStyle = [new Style({
    //           fill: new StyleFill({ color: 'rgba(255, 255, 255, 0.4)' }),
    //           stroke: new StyleStroke({
    //             color: '#045578',
    //             width: 2,
    //             lineDash: [6, 4]
    //           })
    //         })]
    //       }
    //       if (type === 'areaicon') {
    //         selectStyle = [new Style({
    //           image: new StyleIcon({
    //             src: 'https://p.ananas.chaoxing.com/star3/origin/93f06f6eaf18f318ce99392322d2309d.png',
    //             scale: 1.4
    //           })
    //         })]
    //       }
    //       return selectStyle
    //     }
    //   })

    //   this.map.addInteraction(this.selectinter)
    //   // this.selectedFeatures = this.selectinter.getFeatures()
    //   let that = this
    //   this.selectinter.on('select', function(evt) {
    //     // //////console.log(`this.selectinter.getFeatures()`, that.selectinter.getFeatures());
    //     if (that.selectinter.getFeatures().getArray().length === 0) {
    //       that.removeModify()
    //       that.removeTranslate()
    //     } else {

    //       let type = that.selectinter.getFeatures().getArray()[0].get('type')
    //       let dragId = that.selectinter.getFeatures().getArray()[0].get('id')
    //       if (type && type.includes('area')) {
    //           /** 选中当前区域列表、ICON、LINE  **/
    //         let selectItem = that.areaList.find(item => { return item.id === dragId})

    //         that.setSelectData(selectItem)
    //         that.adddrawSourceTranslate()
    //       } else {
    //         let selectItem
    //         that.areaList.forEach(item => {
    //           if (item.data.length > 0) {
    //             item.data.forEach(elem => { if (elem === dragId) selectItem = item })
    //           }
    //         })
    //         //////console.log(`selectItem`, selectItem);
    //         if (selectItem) that.setSelectData(selectItem)
    //         that.addiconSourceModify(selectItem)
    //       }
    //     }
    //   })
    // },
    //     /**
    //  * 框选绘制元素
    //  */
    //  adddragboxInteraction () {
    //   this.dragboxinter = new DragBox({
    //     condition: platformModifierKeyOnly,
    //   })
    //   this.map.addInteraction(this.dragboxinter)
    //   this.dragboxinter.on('boxstart', () => {
    //     this.selectedFeatures = []
    //   })
    //   this.dragboxinter.on('boxend', () => {
    //     const boxExtent = this.dragboxinter.getGeometry().getExtent()
    //     const worldExtent = this.map.getView().getProjection().getExtent()
    //     const worldWidth = getWidth(worldExtent)
    //     const startWorld = Math.floor((boxExtent[0] - worldExtent[0]) / worldWidth)
    //     const endWorld = Math.floor((boxExtent[2] - worldExtent[0]) / worldWidth)
    //     for (let world = startWorld; world <= endWorld; ++world) {
    //       const left = Math.max(boxExtent[0] - world * worldWidth, worldExtent[0])
    //       const right = Math.min(boxExtent[2] - world * worldWidth, worldExtent[2])
    //       const extent = [left, boxExtent[1], right, boxExtent[3]]
    //       const boxFeatures = this.iconSource.getFeaturesInExtent(extent).filter((feature) =>
    //         feature.getGeometry().intersectsExtent(extent)
    //       )
    //       this.selectedFeatures = boxFeatures
    //     }
    //     let that = this
    //     this.resetAreaParams()
    //     this.boxId++
    //     this.editareaList(this.selectedFeatures)
    //     this.$emit('drawarea', true)
    //   })
    // },
    markermoveend(val) {
      //////console.log(`val`, val);
      if (this.id === 1) {
        // 点击单个路线时 禁止缩放更新数据
        if (this.routePoint.length > 0) return;
        // 非遗模版 地点数据 无层级字段 禁止缩放获取层级数据
        if (this.form.cTemplateScore === 1) {
          this.culturalform.page = 1;
          this.getIntangibleCulturalHeritageData();
          if (this.isMobileflag) this.removeDrawsource();
          return;
        }
        this.popshowflag = false;
        this.removeAlliconsource();
        let zoom = val;
        let minZoom = this.mapview.minZoom;
        if (this.isMobileflag) {
          let Difference = Math.round(this.jsonOption.screen.pc.view.zoom) - Math.round(this.jsonOption.screen.app.view.zoom);
          //////console.log(`Difference`, Difference)
          zoom += Difference;
        }
        let orData = [];
        for (let i = minZoom; i <= zoom; i++) {
          orData.push({
            alias: "map_level",
            compt: "editinput",
            express: "===",
            val: i
          });
        }
        this.searchStr.filters.forEach(item => {
          if (item.model === 1) item.filters = orData;
        });
        this.pointform.searchStr = encodeURI(JSON.stringify(this.searchStr));
        this.pointform.page = 1;
        this.pointList = [];
        this.getpointData();
      } else {
        this.$emit("markermoveend", val);
      }
    },
    singleclick(val) {
      this.SET_COORDINATE(val);
    },
    /**
     * 定位点击操作
     * @param {Object} feature 选中数据
     */
    markerclick(feature) {
      console.log("feature");
      this.pointdetail = {};
      this.popshowflag = false;
      if (!this.isMobileflag) document.querySelector(".map_content").style.zIndex = 2;
      if (feature === undefined) return;
      if (!this.isMobileflag) document.querySelector(".map_content").style.zIndex = 5;
      // 判断feature类型
      let gtype = feature.getGeometry().getType();
      // point显示弹窗详情
      if (gtype === "Point") {
        let id = feature.get("id");
        let score = feature.get("score");
        let currentInfo = "";
        if (this.pointList.length > 0) currentInfo = this.pointList.find(item => {
          return item.id === id;
        });
        if (this.mapculturalList.length > 0) currentInfo = this.mapculturalList.find(item => {
          return item.id === id;
        });
        if (currentInfo === undefined) return;
        // 标准模版获取弹窗
        if (score === 0) this.standardDetail(currentInfo);
        // 非遗模版获取弹窗
        if (score === 1) this.culturalDetail(currentInfo, feature);
      }
      // 总地图点击进入分地图
      if (gtype === "Polygon" && this.form.ishaschild === "是" && this.id === 1) {
        let code = feature.get("code");
        let that = this;
        let mapform = {
          deptId: this.query.fid,
          formId: "177623",
          page: 1,
          limit: 100,
          searchStr: {
            model: 0,
            filters: [{
              model: 0,
              filters: [{
                alias: "50",
                compt: "editinput",
                express: "like",
                val: code
              }]
            }]
          }
        };
        mapform.searchStr = encodeURI(JSON.stringify(mapform.searchStr));
        this.$api.singleadvanceSearch(mapform).then(res => {
          if (res.totalRow > 0) {
            let cquery = location.hash.split("?")[1];
            let cparams = cquery.split("&");
            cparams = cparams.map(item => {
              let itemarr = item.split("=");
              if (itemarr[0] === "formUserId") {
                itemarr[1] = res.dataList[0].id;
                item = itemarr.join("=");
              }
              return item;
            });
            window.location.href = location.protocol + "//" + location.host + location.pathname + "?page=superMapv2?" + cparams.join("&");
          }
        });
      }
      // LineString路线点击显示详情
      if (gtype === "LineString" && feature.get("type") === "allroute") {
        let id = feature.get("id");
        let routeItem = this.maprouteList.find(item => {
          return item.id === id;
        });
        if (routeItem !== undefined) {
          this.routePop = true;
          this.routeDetail = routeItem;
        }
      }
      if (gtype === "Point" && feature.get("type") === "location") {
        ElMessage({
          message: "【仅用户在地图所选区域内生效】",
          type: "warning"
        });
      }
    },
    /**
     * 标准模版获取点位详情
     * @param {Object} feature 选中数据
     */
    standardDetail(currentInfo) {
      let formatinfo = {};
      Object.keys(currentInfo.itemformdata).forEach(key => {
        formatinfo[key] = currentInfo.itemformdata[key];
      });
      formatinfo.audio = formatinfo.audio.length > 0 ? formatinfo.audio.map(item => {
        item.title = item.name.replace(`.${item.suffix}`, "");
        this.$api.getUrlByObjectId(item.objectId).then(res => {
          item.url = res.http;
        });
        return item;
      }) : "";
      formatinfo.video = formatinfo.video.length > 0 ? formatinfo.video.map(item => {
        item.title = item.name.replace(`.${item.suffix}`, "");
        this.$api.getUrlByObjectId(item.objectId).then(res => {
          item.url = res.http;
        });
        return item;
      }) : "";
      formatinfo.audiodesc = formatinfo.audiodesc && formatinfo.audiodesc.length > 0 ? formatinfo.audiodesc.map(item => {
        item.title = item.name.replace(`.${item.suffix}`, "");
        this.$api.getUrlByObjectId(item.objectId).then(res => {
          item.url = res.http;
        });
        return item;
      }) : "";
      //////console.log(`formatinfo.video`, formatinfo.video);

      if (formatinfo["42"] === "弹窗") {
        this.pointdetail = formatinfo;
        this.popshowflag = true;
      }
      if (formatinfo["42"] === "链接" && formatinfo["44"] !== "") {
        let url = formatinfo["44"];
        if (formatinfo["44"].includes("superMapv2")) {
          let cparams = formatinfo["44"].split("?")[1];
          url = location.protocol + "//" + location.host + location.pathname + "?page=superMapv2?" + cparams;
        }
        window.open(url);
      }
    },
    /**
     * 非遗模版获取点位详情
     * @param {Object} feature 选中数据
     */
    culturalDetail(currentInfo, feature) {
      let formatinfo = {};
      let coordinate = feature.xy ? feature.xy : feature.get("xy");
      Object.keys(currentInfo.itemformdata).forEach(key => {
        formatinfo[key] = currentInfo.itemformdata[key];
      });
      formatinfo.id = currentInfo.id;
      formatinfo.coordinate = coordinate;
      formatinfo.gateway = formatinfo.gateway = formatinfo.detailUrl !== "" ? `${formatinfo.detailUrl}${formatinfo.detailUrl.includes("?") ? "&" : "?"}mapid=${formatinfo.number}` : "";
      formatinfo.pixelcoordinate = this.$refs.mapv2assembly.getmapPixelFromCoordinate(currentInfo);
      this.pointdetail = formatinfo;
      this.popshowflag = true;
      this.getCulturalperson(formatinfo);
      this.getCulturalpic(formatinfo);
      this.getCulturalvideo(formatinfo);
      // 客家(闽西)非遗博物馆 龙岩
      if (this.query.fid === "138053") {
        this.getSeminar(formatinfo);
        this.popmodeltype = 4; //先定制后删除
      }
      if ((this.popmodeltype === 1 || this.popmodeltype === 4) && !this.isMobileflag) {
        this.$nextTick(() => {
          this.$refs.mapv2assembly.addpopOverLay(coordinate);
        });
      }
    },
    /**
     * 点位获取对应非遗传承人数据
     * @param {Object} feature 选中数据
     */
    getCulturalperson(formatinfo) {
      let searchStr = {
        model: 0,
        filters: [{
          model: 0,
          filters: [{
            alias: "project_name",
            compt: "editinput",
            express: "===",
            val: formatinfo.title
          }]
        }]
      };
      this.culturalpersonform.searchStr = encodeURI(JSON.stringify(searchStr));
      this.culturalpersonform.deptId = this.query.fid;
      let that = this;
      this.$api.singleadvanceSearchv2(this.culturalpersonform).then(res => {
        // //////console.log(res);
        if (res.totalRow > 0) {
          if (that.culturalpersonform.page === 1) that.mapculturalpersonList = [];
          res.dataList.forEach((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
          });
          that.mapculturalpersonList = that.culturalpersonform.page === 1 ? res.dataList : that.mapculturalpersonList.concat(res.dataList);
          if (res.totalPage > 1) that.culturalpersonform.page++;
          // if (res.totalPage >= that.pointform.page) that.getpointData()
          that.pointdetail.person = that.mapculturalpersonList;
        }
      });
    },
    /**
     * 点位获取对应项目图片表单数据
     * @param {Object} feature 选中数据
     */
    getCulturalpic(formatinfo) {
      let searchStr = {
        model: 0,
        filters: [{
          model: 0,
          filters: [{
            alias: this.query.fid === "138053" ? "number" : "19",
            compt: "editinput",
            express: "===",
            val: formatinfo.number
          }]
        }]
      };
      if (this.query.fid === "138053") {
        this.culturalpicform.formId = "1539909";
        this.culturalpicform.t = "28cfc16722e657e0a8544fcc4170635a1838e364615b9ea94f1161c5b1664675";
      }
      this.culturalpicform.searchStr = encodeURI(JSON.stringify(searchStr));
      this.culturalpicform.deptId = this.query.fid;
      let that = this;
      this.$api.singleadvanceSearchv2(this.culturalpicform).then(res => {
        // //////console.log(res);
        if (res.totalRow > 0) {
          if (that.culturalpicform.page === 1) that.mapculturalpicList = [];
          res.dataList.forEach((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
          });
          that.mapculturalpicList = that.culturalpicform.page === 1 ? res.dataList : that.mapculturalpicList.concat(res.dataList);
          if (res.totalPage > 1) that.culturalpicform.page++;
          // if (res.totalPage >= that.pointform.page) that.getpointData()
          that.pointdetail.pictureList = that.mapculturalpicList;
        }
      });
    },
    /**
     * 点位获取对应项目视频表单数据
     * @param {Object} feature 选中数据
     */
    getCulturalvideo(formatinfo) {
      let searchStr = {
        model: 0,
        filters: [{
          model: 0,
          filters: [{
            alias: this.query.fid === "138053" ? "number" : "1",
            compt: this.query.fid === "138053" ? "editinput" : "selectbox",
            express: "===",
            val: this.query.fid === "138053" ? formatinfo.number : [formatinfo.title]
          }]
        }]
      };
      if (this.query.fid === "138053") {
        this.culturalvideoform.formId = "1540105";
        this.culturalvideoform.t = "af229fb2c9b88028bfb98461282282f20b24954a46827574c4a07d6218162bb6";
      }
      this.culturalvideoform.searchStr = encodeURI(JSON.stringify(searchStr));
      this.culturalvideoform.deptId = this.query.fid;
      let that = this;
      this.$api.singleadvanceSearchv2(this.culturalvideoform).then(res => {
        // //////console.log(res);
        if (res.totalRow > 0) {
          if (that.culturalvideoform.page === 1) that.mapculturalvideoList = [];
          res.dataList.forEach((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
          });
          that.mapculturalvideoList = that.culturalvideoform.page === 1 ? res.dataList : that.mapculturalvideoList.concat(res.dataList);
          // if (res.totalPage > 1) that.culturalvideoform.page++
          // if (res.totalPage >= that.pointform.page) that.getpointData()
          that.pointdetail.videoList = that.mapculturalvideoList;
        }
      });
    },
    /**
     * 点位获取对应传习所表 【龙岩地图定制】 202406251652 看后期如何定制 url：seminar202406251701
     * @param {Object} feature 选中数据
     */
    getSeminar(formatinfo) {
      let seminar = {
        formId: "1575388",
        page: 1,
        limit: 100,
        searchStr: "",
        t: "4f4bf90d9e5aaf56878c6788d5471a5acb372f5a11d78917d362ce3fb72373ed"
      };
      let searchStr = {
        model: 0,
        filters: [{
          model: 0,
          filters: [{
            alias: "3",
            compt: "editinput",
            express: "===",
            val: formatinfo.number
          }]
        }]
      };
      seminar.searchStr = encodeURI(JSON.stringify(searchStr));
      seminar.deptId = this.query.fid;
      let that = this;
      this.$api.singleadvanceSearchv2(seminar).then(res => {
        // //////console.log(res);
        if (res.totalRow > 0) {
          res.dataList.forEach((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
          });
          that.pointdetail.seminarList = res.dataList;
        }
      });
    },
    /**
     * 弹窗关闭事件
     */
    closeHandle() {
      this.popshowflag = false;
      this.pointdetail = {};
      if (!this.isMobileflag) document.querySelector(".map_content").style.zIndex = 2;
    },
    /**
     * 分类选择事件
     */
    typeselect(val) {
      if (this.id === 1) {
        this.typeClick(val);
      } else {
        this.$emit("typeselect", val);
      }
    },
    /**
     * 分类数据格式化
     */
    typebtnFormat(val) {
      let typebtn = [...val];
      this.typebtn = [];
      typebtn.forEach(elem => {
        let item = {
          ...elem
        };
        if (item.imgList && item.imgList.length > 0) {
          item.backgroundImage = "url('" + getImg(item.imgList[0]) + "')";
          item.backgroundSize = "100% 100%";
          item.backgroundRepeat = "no-repeat";
        }
        item.textAlign = "center";
        delete item.imgList;
        let newitem = {};
        Object.keys(item).forEach(child => {
          if (this.isMobileflag) {
            newitem[child] = /px$/.test(item[child]) ? `${parseFloat((parseInt(item[child]) / 2 / 37.5).toFixed(6))}rem` : item[child];
          } else {
            newitem[child] = /px$/.test(item[child]) ? `${parseFloat((parseInt(item[child]) / 1920 * 100).toFixed(6))}vw` : item[child];
          }
        });
        this.typebtn.push(newitem);
      });
    },
    removeAlliconsource() {
      this.$refs.mapv2assembly.removeAlliconsource();
    },
    saveDrawHandle() {
      this.$refs.mapv2assembly.saveDrawHandle();
    },
    updateMap() {
      this.$refs.mapv2assembly.updateMap();
    },
    removeDrawsource() {
      this.$refs.mapv2assembly.removeDrawsource();
    },
    removeRoutesource() {
      this.$refs.mapv2assembly.removeRoutesource();
    },
    isHasallarea(val) {
      let that = this;
      let mapform = {
        deptId: this.query.fid,
        formId: "177623",
        page: 1,
        limit: 100,
        searchStr: {
          model: 0,
          filters: [{
            model: 0,
            filters: [{
              alias: "ishaschild",
              compt: "radiobutton",
              express: "===",
              val: ["是"]
            }]
          }]
        }
      };
      mapform.searchStr = encodeURI(JSON.stringify(mapform.searchStr));
      this.$api.singleadvanceSearch(mapform).then(res => {
        if (res.totalRow > 0) {
          this.showgolist = val.ishaschild === "是" ? false : true;
          if (this.showgolist) this.showgolistId = res.dataList[0].id;
        }
      });
    },
    golist() {
      let cquery = location.hash.split("?")[1];
      let cparams = cquery.split("&");
      cparams = cparams.map(item => {
        let itemarr = item.split("=");
        if (itemarr[0] === "formUserId") {
          itemarr[1] = this.showgolistId;
          item = itemarr.join("=");
        }
        return item;
      });
      window.location.href = location.protocol + "//" + location.host + location.pathname + "?page=superMapv2?" + cparams.join("&");
    },
    /**
     * 获取非遗项目表单结构数据
     */
    getCulturalFormStruct() {
      let params = {
        deptId: this.query.fid,
        formId: "cultural_heritage_project"
      };
      this.$api.formStruct(params).then(res => {
        this.cstructList = JSON.parse(JSON.stringify(res));
        this.cpList = getformatstruct(res, this.cform, this.cformlabel, this.cformfield, this.cformoption);
        this.defaultcform = Object.assign({}, this.cform);
      });
    },
    setComonStyle() {
      document.querySelector("html").style.fontSize = `${window.screen.width / 10}px`;
    },
    /**
     * 获取地图设置行
     */
    getMapData() {
      let that = this;
      this.$api.singleformUserId(this.query.fid, "177623", this.query.formUserId).then(res => {
        if (res.formUserList.length > 0) {
          that.cformUser = res.formUserList[0];
          let formatData = {};
          res.formUserList[0].formData.forEach(item => {
            formatData[item.alias] = getformitemsdata(item);
          });
          that.formatData = formatData;
          document.title = formatData.toptitle;
          // 处理地图view相关字段
          that.getFormStruct();
          // 增加浏览量
          if (formatData.visits !== undefined) that.addVisits();
        }
      });
    },
    /**
     * 获取地图配置表单结构
     */
    getFormStruct() {
      let params = {
        deptId: this.$route.query.fid,
        formId: 177623
      };
      this.$api.formStruct(params).then(res => {
        this.sList = getformatstruct(res, this.form, this.formlabel, this.formfield, this.formoption);
        this.mapview = this.mapv2info.view;
        this.editlogic(this.formatData);
        this.gettypeList();
      });
    },
    /**
     * 配置页编辑逻辑处理
     */
    editlogic(data) {
      this.mapLayers.tiles = true;
      this.mapLayers.json = true;
      this.mapLayers.static = true;
      Object.keys(data).forEach(item => {
        this.form[item] = data[item];
      });
      this.jsonOption = {
        ...JSON.parse(this.form.jsontxt.replace(/(<\/?p.*?>)/gi, ""))
      };
      console.log("this.form");
      console.log(this.form);
      // console.log(this.jsonOption.drawlayer);
      // if(this.query.formUserId==1514653091){
      //   localStorage.setItem('thisForm',JSON.stringify(this.jsonOption ))
      // }else{
      //     this.jsonOption=JSON.parse(localStorage.getItem('thisForm'))
      // }
      // this.jsonOption.drawlayer.drawJson=''
      // 复原
      // const htmlString = '<p element-id="tb8h6msa" style="text-align: left;">{"view":{"zoom":7.5,"minZoom":7,"maxZoom":12,"adcode":"420000","center":[112.198572,30.584355],"extent":[108.371295,29.029307,116.13521,33.275484],"scale":true,"rotate":true,"translate":true},"style":{"showtype":1,"showlist":1,"typeall":true,"typeallname":"全部","routebutton":2,"routebuttontext":"路线推荐","routelinetype":1,"typeStyleIndex":0,"pointStyleIndex":0,"popStyleIndex":0,"listStyleIndex":0,"typedisplay":{"display":"block"},"typebtn":[{"color":"#333333","fontFamily":"Microsoft Yahei","fontWeight":"normal","fontSize":"12px","imgList":[],"width":"220px","lineHeight":"40px","height":"40px","margin":"5px"},{"color":"#333333","fontFamily":"Microsoft Yahei","fontWeight":"normal","fontSize":"12px","imgList":[],"width":"220px","lineHeight":"40px","height":"40px","margin":"5px"}],"pointtext":{"color":"#000000","fontFamily":"Microsoft Yahei","fontWeight":"bold","fontSize":"14px","fill":"rgba(255,255,255,0)","stroke":"","limit":{"flag":false,"rows":1,"len":10}},"routebtn":[{"color":"#333333","fontFamily":"Microsoft Yahei","fontWeight":"normal","fontSize":"12px","imgList":[],"width":"220px","lineHeight":"40px","height":"40px","margin":"5px"}],"logopos":{"pIndex":0,"ptype":"left-top","left":"0px","top":"0px","width":"240px"},"pickeypos":{"pIndex":0,"ptype":"left-top","left":"0px","top":"0px","width":"240px"},"typepos":{"pIndex":0,"ptype":"left-top","left":"0px","top":"0px","width":"240px"},"pointpic":{"scale":0.05,"anchor":[2.8,0.5]},"pointicon":{"scale":0.3,"anchor":[0.5,1]},"popcolor":"rgba(51,51,51,1)","listpos":{"pIndex":0,"ptype":"left-top","left":"0px","top":"0px","width":"240px"},"routepos":{"pIndex":0,"ptype":"left-top","left":"0px","top":"0px","width":"240px"},"routepopcolor":"rgba(51,51,51,1)"},"geojson":{"adcode":420000,"name":"湖北省","center":[114.298572,30.584355],"centroid":[112.271301,30.987527],"childrenNum":17,"level":"province","parent":{"adcode":100000},"subFeatureIndex":16,"acroutes":[100000],"__gid":517519,"parentKey":"0.911693871965995"},"senior":{"visit":false,"realview":0,"customview":0,"service":false,"footerinfo":"","effect":false,"draw":false,"reset":false},"coordinate":"116.751350, 29.444743","drawlayer":{"toolsIndex":2,"showtranfer":false,"linestyle":{"width":5,"color":"rgba(0,56,238,0.34901960784313724)","lineDash":[4,2]},"currentTextstyle":{},"textstyle":{},"currentList":[],"currentCoordinate":[],"drawtextblocksum":0,"deleteList":[],"drawJson":"","drawarea":[{"id":1,"iconcenter":[],"data":[],"datafirstcenter":[]}]},"screen":{}}</p>';
      // const jsonStringMatch = htmlString.match(/<p[^>]*>(.*?)<\/p>/)[1];
      // this.jsonOption = JSON.parse(jsonStringMatch.replace(/&quot;/g, '"'));

      //console.log(' this.jsonOption.drawlayer.drawJso')
      //console.log( this.jsonOption.drawlayer.drawJson)
      this.jsonOption.drawlayer.drawJson = "";
      if (this.jsonOption.screen && Object.keys(this.jsonOption.screen).length > 0) {
        let screenData = this.isMobileflag ? this.jsonOption.screen.app : this.jsonOption.screen.pc;
        Object.keys(screenData).forEach(item => {
          this.jsonOption[item] = screenData[item];
        });
      }
      //////console.log(`this.jsonOption`, this.jsonOption);
      this.mapviewhandle(this.jsonOption.view);
      this.form.showtype = this.jsonOption.style.showtype;
      this.form.showlist = this.jsonOption.style.showlist;
      this.form.scale = this.jsonOption.view.scale;
      this.form.rotate = this.jsonOption.view.rotate;
      this.form.typeall = this.jsonOption.style.typeall !== undefined ? this.jsonOption.style.typeall : true;
      this.form.typeallname = this.jsonOption.style.typeallname ? this.jsonOption.style.typeallname : "全部";
      this.form.showroute = this.jsonOption.style.showroute ? this.jsonOption.style.showroute : 1;
      this.form.routelinetype = this.jsonOption.style.routelinetype ? this.jsonOption.style.routelinetype : 1;
      this.SET_MAPFORM(this.form);
      this.SET_MAPVIEW(this.jsonOption.view);
      this.SET_MAPSENIOR(this.jsonOption.senior);
      this.SET_MAPSTYLEITEM({
        showtype: this.jsonOption.style.showtype
      });
      this.SET_MAPSTYLEITEM({
        showlist: this.jsonOption.style.showlist
      });
      this.SET_MAPSTYLEITEM({
        typeall: this.form.typeall
      });
      this.SET_MAPSTYLEITEM({
        typeallname: this.form.typeallname
      });
      this.SET_MAPSTYLEITEM({
        showroute: this.jsonOption.style.showroute
      });
      this.SET_MAPSTYLEITEM({
        routelinetype: this.form.routelinetype
      });
      this.mapview = this.jsonOption.view;
      this.mapstyle = this.jsonOption.style;
      this.mapstyle.typeall = this.form.typeall;
      this.mapstyle.typeallname = this.form.typeallname;
      this.senior = this.jsonOption.senior;
      if (this.form.static_img && this.form.static_img.length > 0) {
        this.mapLayers.staticimage = getImg(this.form.static_img[0]);
        this.mapLayers.tiles = false;
      }
      // this.mapLayers.route = this.form.showroute === 1 ? true : false

      // 判断当前地图模版 score  0标准模版  1非遗模版
      this.formoption.mapTemplate.forEach(elem => {
        if (this.formatData.mapTemplate === elem.title) {
          this.cTemplateScore = elem.score;
          this.SET_MAPFORMITEM({
            cTemplateScore: elem.score
          });
        }
      });
      this.SET_MAPDRAWLAYER(this.jsonOption.drawlayer);
      this.mapLayers.drawelement = this.jsonOption.drawlayer;
      this.mapformHandle(this.form);
      this.$nextTick(() => {
        //////console.log(`this.jsonOption.style`, this.jsonOption.style)
        this.styleHandle(this.jsonOption.style);
        this.typebtnFormat(this.jsonOption.style.typebtn);
        this.popcolorFormat(this.jsonOption.style.popcolor);
      });
      // 是否含有乡镇街道
      if (Object.prototype.toString.call(this.jsonOption.geojson) === "[object Array]" && this.jsonOption.geojson[0].code) {
        this.streetcode = this.jsonOption.geojson.map(item => {
          return item.code;
        });
      } else if (Object.prototype.toString.call(this.jsonOption.geojson) === "[object Object]" && this.jsonOption.geojson.code) {
        this.streetcode = [this.jsonOption.geojson.code];
      }
      let adcode = this.jsonOption.view.adcode;
      if (this.streetcode.length > 0) {
        axios.get(`${process.env.NODE_ENV === "development" ? "/fileapi" : location.origin}/frontendTest1/openlayers/data/${adcode}.json`).then(res => {
          if (res.status === 200) {
            let jsondata = res.data;
            let filterJson = [];
            this.streetcode.forEach(street => {
              jsondata.features.forEach(feature => {
                if (Number(feature.properties.code) === Number(street)) filterJson.push(feature);
              });
            });
            jsondata.features = filterJson;
            this.maplayer.geojson = jsondata;
            this.isloadingmap = true;
          }
        }).catch(error => {});
        return;
      }
      // 自定义json数据
      if (this.jsonOption.view.adcode === "region") {
        let datacoord = this.jsonOption.geojson.features[0].geometry.coordinates[0];
        let changedata = [];
        datacoord.forEach(elem => {
          changedata.push(transform(elem, "EPSG:4326", "EPSG:3857"));
        });
        this.jsonOption.geojson.features[0].geometry.coordinates[0] = changedata;
        this.mapLayers.geojson = {
          type: "FeatureCollection",
          features: this.jsonOption.geojson.features
        };
      }
      this.loadingmap = true;
    },
    mapviewhandle(view) {
      ////console.log('view')
      let center = view.center;
      this.form.centerX = center[0];
      this.form.centerY = center[1];
      this.form.minZoom = view.minZoom;
      this.form.maxZoom = view.maxZoom;
      this.form.zoom = view.zoom;
      this.form.static_map_min_level = view.minZoom;
      this.form.static_map_max_level = view.maxZoom;
      this.form.current_level = view.zoom;
      this.form.map_center = center.join(",");
      this.form.transform_extent = view.extent.join(",");
    },
    /**
     * 获取分类列表数据
     */
    gettypeList() {
      let that = this;
      this.typeform.deptId = this.query.fid;
      this.$api.singleadvanceSearch(this.typeform).then(res => {
        if (res.totalRow > 0) {
          this.typeList = [];
          res.dataList.forEach((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
          });
          this.typeList = res.dataList.sort((a, b) => Number(a.itemformdata.sortId) - Number(b.itemformdata.sortId));
          if (!this.mapstyle.typeall) {
            this.searchStr.filters.push({
              model: 0,
              filters: [{
                alias: "map_type2",
                compt: "editinput",
                express: "===",
                val: this.typeList[0].itemformdata.title
              }]
            });
          }
          // //////console.log(`typeList`, this.typeList)
        }
        ////console.log(`this.formatData.title`, this.formatData.title)
        // 处理地点管理表 请求参数
        this.pointform.deptId = this.query.fid;
        this.searchStr.filters[0].filters[0].val = "湖北省高等教育综合服务系统展示版";
        console.log("this.searchStr");
        console.log(this.searchStr);
        // ||this.formatData.title
        let zoom = this.mapview.zoom;
        let minZoom = this.mapview.minZoom;
        if (this.isMobileflag) {
          let Difference = Math.round(this.jsonOption.screen.pc.view.zoom) - Math.round(this.jsonOption.screen.app.view.zoom);
          //////console.log(`Difference`, Difference)
          zoom += Difference;
        }
        let orData = [];
        for (let i = minZoom; i <= zoom; i++) {
          orData.push({
            alias: "map_level",
            compt: "editinput",
            express: "===",
            val: i
          });
        }
        this.searchStr.filters.forEach(item => {
          if (item.model === 1) item.filters = orData;
        });
        // console.log("this.searchStr123", this.searchStr);
        // this.searchStr.filters[1].filters[0].val = 7;
        this.pointform.searchStr = encodeURI(JSON.stringify(this.searchStr));
        this.getpointData();

        // 处理非遗项目表单数据
        if (this.cTemplateScore === 1) {
          let searchStr = {
            model: 0,
            filters: [{
              model: 0,
              filters: [{
                alias: "correlation_map",
                compt: "selectbox",
                express: "===",
                val: ["是"]
              }]
            }]
          };
          this.culturalform.searchStr = encodeURI(JSON.stringify(searchStr));
          this.culturalform.deptId = this.query.fid;
          this.getIntangibleCulturalHeritageData();
          if (this.isMobileflag) this.removeDrawsource();
        }
      });
    },
    /**
     * 获取地点管理表数据
     */
    getpointData(val) {
      let that = this;
      console.log("pointform");
      console.log(this.pointform);
      this.$api.singleadvanceSearch(this.pointform).then(res => {
        console.log(res);
        if (res.totalRow > 0) {
          if (that.pointform.page === 1) that.pointList = [];
          let dataList = that.formdataformat(res);
          that.pointList = that.pointform.page === 1 ? dataList : that.pointList.concat(dataList);
          if (res.totalPage > 1) that.pointform.page++;
          if ((res.totalPage === 1 || res.totalPage === that.pointform.page) && val === undefined) that.getroutetypeData();
          if (res.totalPage > 1 && res.totalPage >= that.pointform.page) that.getpointData();
        }
      });
    },
    /**
     * 点击类型操作
     * @param {Object} data 选中数据及索引 index item
     */
    typeClick(data) {
      this.cType = data;
      this.popshowflag = false;
      this.removeAlliconsource();
      let dindex = data.index;
      let val = dindex === 0 ? "" : !data.child ? data.item.itemformdata : data.child;
      let typesearchflag = false;
      if (dindex === 0) {
        this.searchStr.filters.forEach((item, index) => {
          if (item.filters.length > 0 && item.filters[0].alias === "map_type2") this.searchStr.filters.splice(index, 1);
        });
      } else {
        this.searchStr.filters.forEach(item => {
          if (item.filters.length > 0 && item.filters[0].alias === "map_type2") {
            item.filters[0].val = val.title;
            typesearchflag = true;
          }
        });
        if (!typesearchflag) {
          this.searchStr.filters.push({
            model: 0,
            filters: [{
              alias: "map_type2",
              compt: "editinput",
              express: "like",
              val: val.title
            }]
          });
        }
      }
      let zoom = this.mapview.zoom;
      let minZoom = this.mapview.minZoom;
      if (this.isMobileflag) {
        let Difference = Math.round(this.jsonOption.screen.pc.view.zoom) - Math.round(this.jsonOption.screen.app.view.zoom);
        //////console.log(`Difference`, Difference)
        zoom += Difference;
      }
      let orData = [];
      for (let i = minZoom; i <= zoom; i++) {
        orData.push({
          alias: "map_level",
          compt: "editinput",
          express: "===",
          val: i
        });
      }
      this.searchStr.filters.forEach(item => {
        if (item.filters.length > 0 && item.filters[0].alias === "40" && item.filters[0].val === "") item.filters[0].val = this.form.title;
        if (item.model === 1) item.filters = orData;
      });
      if (this.pointform.deptId === undefined) this.pointform.deptId = this.query.fid;
      this.pointform.searchStr = encodeURI(JSON.stringify(this.searchStr));
      this.pointform.page = 1;
      this.pointList = [];
      this.getpointData();
      // 点击非全部类型 隐藏路线列表
      this.$refs.routelist.routebtnHide();
      this.$refs.mapv2assembly.removeRoutesource();
    },
    /**
     * 获取非遗项目表单数据
     */
    getIntangibleCulturalHeritageData() {
      let that = this;
      this.$api.singleadvanceSearchv2(this.culturalform).then(res => {
        // //////console.log(res);
        if (res.totalRow > 0) {
          if (that.culturalform.page === 1) that.mapculturalList = [];
          that.culturaldataformat(res);
          if (res.totalPage > 1) that.culturalform.page++;
          if (res.totalPage > 1 && res.totalPage >= that.culturalform.page) that.getIntangibleCulturalHeritageData();
        }
      });
    },
    culturaldataformat(res) {
      res.dataList.forEach((item, index) => {
        let itemformdata = item.formIdValueData;
        let itemformat = {};
        Object.keys(itemformdata).forEach(key => {
          itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
        });
        if (this.typeList.length > 0) {
          let type = this.typeList.find(elem => {
            return elem.itemformdata.title === itemformat.level;
          });
          if (type && type.itemformdata.icon.length > 0) itemformat.icon = getImg(type.itemformdata.icon[0]);
        }
        item.itemformdata = itemformat;
      });
      this.mapculturalList = this.culturalform.page === 1 ? res.dataList : this.mapculturalList.concat(res.dataList);
    },
    pointlistClick(item) {
      this.$refs.pointlist.listDown();
      this.pointdetail = {};
      this.popshowflag = false;
      let citem = item.itemformdata;
      if (citem.correlation_address.length > 0) {
        let gd = bd_decrypt(Number(citem.correlation_address[0].lng), Number(citem.correlation_address[0].lat));
        let x = Number(gd.lng);
        let y = Number(gd.lat);
        this.culturalDetail(item, {
          xy: [x, y]
        });
      }
    },
    listUp() {
      this.pointdetail = {};
      this.popshowflag = false;
    },
    formdataformat(res) {
      return res.dataList.map((item, index) => {
        let itemformdata = item.formIdValueData;
        let itemformat = {};
        Object.keys(itemformdata).forEach(key => {
          itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
        });
        item.itemformdata = itemformat;
        return item;
      });
    },
    getroutetypeData() {
      let that = this;
      this.rtypeform.deptId = this.query.fid;
      let searchStr = {
        model: 0,
        filters: [{
          model: 0,
          filters: [{
            alias: "mapbelongId",
            compt: "editinput",
            express: "===",
            val: this.formatData.onlyid
          }]
        }]
      };
      this.rtypeform.searchStr = encodeURI(JSON.stringify(searchStr));
      this.$api.singleadvanceSearchv2(this.rtypeform).then(res => {
        // //////console.log(res);
        if (res.totalRow > 0) {
          if (that.rtypeform.page === 1) that.rtypeList = [];
          let dataList = that.formdataformat(res);
          let sortdataList = dataList.sort((a, b) => Number(a.itemformdata.sortId) - Number(b.itemformdata.sortId));
          that.rtypeList = that.routeform.page === 1 ? sortdataList : that.rtypeList.concat(sortdataList);
          if (res.totalPage > 1) that.rtypeform.page++;
          if (res.totalPage === 1 || res.totalPage === that.rtypeform.page) that.getrouteData();
          if (res.totalPage > 1 && res.totalPage >= that.rtypeform.page) that.getroutetypeData();
        }
      });
    },
    /**
     * 获取路线管理表表单数据
     */
    getrouteData() {
      let that = this;
      this.routeform.deptId = this.query.fid;
      this.$api.singleadvanceSearchv2(this.routeform).then(res => {
        // //////console.log(res);
        if (res.totalRow > 0) {
          if (that.routeform.page === 1) that.maprouteList = [];
          let dataList = that.formdataformat(res);
          that.maprouteList = that.routeform.page === 1 ? dataList : that.maprouteList.concat(dataList);
          if (res.totalPage > 1) that.routeform.page++;
          // if (res.totalPage === 1 || res.totalPage === that.routeform.page) {
          //     if (that.cType === '') that.routeHandle(that.maprouteList)
          // }
          if (res.totalPage > 1 && res.totalPage >= that.routeform.page) that.getrouteData();
        }
      });
    },
    routeChange(val) {
      //////console.log(`routeChange`, val);
      if (val.length === 0) {
        this.typeClick(this.cType === "" ? {
          index: 0,
          item: ""
        } : this.cType);
        return;
      }
      this.mapLayers.route = true;
      this.getsingleroute(val);
    },
    getsingleroute(val) {
      let routePoint = [];
      val.forEach(elem => {
        this.routejson = {
          ...JSON.parse(elem.itemformdata.jsontxt.replace(/(<\/?p.*?>)/gi, ""))
        };
        this.routejson.routedata.forEach(item => {
          let route = this.pointList.find(point => {
            return point.id === item.id;
          });
          if (route !== undefined) routePoint.push(route);
        });
      });
      this.routePoint = routePoint;
      this.setRoutePoint(routePoint);
      this.routeHandle(val);
    },
    routeHandle(val) {
      this.routeAllLen = val.length;
      this.routeAllSource = [];
      let routes = [];
      for (let i = 0; i < this.routePoint.length - 1; i++) {
        let start = this.routePoint[i].itemformdata.map_coordinates.split(",").map(parseFloat);
        let end = this.routePoint[i + 1].itemformdata.map_coordinates.split(",").map(parseFloat);
        routes.push([start, end]);
      }

      // 若存在curvedata参数 代表曲线
      if (this.routejson.curvedata !== undefined && this.form.routelinetype === 3 && this.routejson.curvedata.length > 0) {
        routes.forEach((item, index) => {
          let curveitem = this.routejson.curvedata[index];
          if (curveitem !== null) curveitem.forEach((point, pIndex) => {
            item.splice(pIndex + 1, 0, [point[0], point[1]]);
          });
        });
      }
      if (routes.length === 0) {
        this.routeAllSource = [];
        this.SET_MAPROUTESOURCE([]);
        return;
      }
      if (this.form.routelinetype === 1) {
        this.routeAllSource = [];
        let routeItemAllpath = [];
        this.routeDriving(routes, 0, routeItemAllpath, this.routejson.style, val[0].id);
      }
      if (this.form.routelinetype !== 1) {
        let paths = routes.map(elem => {
          return elem.map(item => {
            return transform([item[0], item[1]], "EPSG:4326", "EPSG:3857");
          });
        });
        //////console.log(`paths`, paths);
        this.SET_MAPROUTESOURCE([{
          path: paths,
          style: this.routejson.style,
          routelinetype: this.form.routelinetype,
          isCurve: false
        }]);
      }
    },
    routeDriving(routes, index, routeItemAllpath, linestyle, id) {
      let route = routes[index];
      if (route === undefined) return;
      let start = new window.BMapGL.Point(route[0][0], route[0][1]);
      let end = new window.BMapGL.Point(route[1][0], route[1][1]);
      let driving = new window.BMapGL.DrivingRoute(this.mapcontainer);
      driving.search(start, end);
      driving.setSearchCompleteCallback(() => {
        let routepath = [];
        if (driving.getResults() === undefined) return;
        let pots = driving.getResults().getPlan(0).getRoute(0).getPath();
        pots.forEach((pot, idx) => {
          let bdTogd = bd_decrypt(pot.lng, pot.lat);
          routepath.push(transform([bdTogd.lng, bdTogd.lat], "EPSG:4326", "EPSG:3857"));
        });
        routeItemAllpath.push(routepath);
        if (routes.length === 1 || index === routes.length - 1) {
          this.routeAllSource.push({
            path: routeItemAllpath,
            style: linestyle,
            id: id
          });
          this.SET_MAPROUTESOURCE(this.routeAllSource);
          // if (this.routeAllSource.length === this.routeAllLen) this.SET_MAPROUTESOURCE(this.routeAllSource)
        }
        if (routes.length > 1 && index <= routes.length - 1) this.routeDriving(routes, index + 1, routeItemAllpath, linestyle, id);
      });
    },
    routeshow(val) {
      this.mapLayers.route = val;
    },
    /**
     * 增加浏览量
     */
    addVisits() {
      let dataList = [];
      dataList.push({
        alias: "onlyid",
        compt: "autonumber",
        values: [{
          val: this.formatData.onlyid
        }]
      });
      dataList.push({
        alias: "title",
        compt: "editinput",
        values: [{
          val: this.formatData.title
        }]
      });
      dataList.push({
        alias: "visits",
        compt: "numberinput",
        values: [{
          val: Number(this.formatData.visits) + 1
        }]
      });
      this.$api.editForm(this.query.fid, this.query.formUserId, encodeURI(JSON.stringify(dataList)), this.cformUser.formId).then(res => {});
    },
    setRoutePoint(val) {
      this.$refs.mapv2assembly.removeAlliconsource();
      this.$refs.mapv2assembly.removeRoutesource();
      this.$refs.mapv2assembly.createPoint(val);
      // this.$refs.mapv2assembly.stopMove(true)
    }
  }
};